<template>
	<div>
		<v-layout
			row wrap justify-end align-center
			class="header-booking-data">
			<v-flex md7 xs10>
				<v-layout row wrap justify-end align-center>
					<v-flex py-0 class="border-select">
						<p>Tipo:</p>
						<span>{{ getTypeAndCodeRoom(bookingData) }}</span>
					</v-flex>
					<v-flex py-0 class="border-select">
						<p>Noches:</p>
						<span>{{ bookingData.numberNights }}</span>
					</v-flex>
					<v-flex py-0 class="border-select">
						<p>Niños:</p>
						<span>
							<img :src="`${$imageS3}/clerkinn/child-icon.svg`"
								alt="" class="mr-2">
							{{ bookingData.summary.booking.childrens }}
						</span>
					</v-flex>
					<v-flex py-0 class="border-select">
						<p>Adultos:</p>
						<span>
							<img :src="`${$imageS3}/clerkinn/adult-icon.svg`"
								alt="" class="mr-2">
							{{ bookingData.summary.booking.adults }}
						</span>
					</v-flex>
					<v-flex py-0 class="border-select">
						<v-layout row wrap>
							<v-flex xs6>
								<p>CHECKIN</p>
								<span>{{ bookingData.bookingStart | parseDate('DD/MM/YYYY') }}</span>
							</v-flex>
							<v-flex xs6>
								<p>CHECKOUT</p>
								<span>{{ bookingData.bookingEnd | parseDate('DD/MM/YYYY') }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs3 pa-0>
						<span class="booking-number">Nº RESERVA
							<span>{{ bookingData.numReservation }}</span>
						</span>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-tabs grow class="checkin-tabs" v-model="active">
					<v-tabs-bar class="transparent">
						<v-tabs-slider class="default-skyblue"></v-tabs-slider>
						<v-tabs-item
							v-for="item in items"
							:key="item.id"
							:href="'#tab-' + item.id"
							:disabled="(!saleId || saleId < 1)
								|| isNoShow">
							{{ item.title }} <span v-if="item.id === 3">({{ totalNotes }})</span>
						</v-tabs-item>
					</v-tabs-bar>
					<v-tabs-items>
						<v-tabs-content
							v-for="i in items.length"
							:key="i"
							:id="'tab-' + i">
							<v-layout row wrap
								v-if="i === 1" my-4>
								<v-flex xs12>
									<div class="bar-data">
										<div class="bar-data-item">
											<p>
												Huésped:
												<span>Nº 1</span>
											</p>
										</div>
										<div class="bar-data-item">
											<p>
												Nº Tarjeta:
												<span v-show="bookingData.customer.data.cardVip">
													Vip
												</span>
												<span>-</span>
												<span v-show="bookingData.customer.data.cardVip">
													{{ bookingData.customer.data.cardVip }}
												</span>
											</p>
										</div>
										<div class="bar-data-item">
											<p>
												<app-type-document :document-id="bookingData.customer.data.documentType"></app-type-document>
												<span>{{ bookingData.customer.data.numDocument }}</span>
											</p>
										</div>
										<div class="bar-data-item">
											<p>
												Nombre:
												<span>{{ bookingData.customer.data.name }}</span>
											</p>
										</div>
										<div class="bar-data-item">
											<p>
												Apellido:
												<span>{{ bookingData.customer.data.lastname }}</span>
											</p>
										</div>
										<div class="bar-data-item">
											<p>
												Fec. Nac.:
												<span>{{ bookingData.customer.data.dateBirth | parseDate('DD/MM/YYYY') }}
													- Adulto</span>
											</p>
										</div>
										<div class="bar-data-item no-border">
											<p>
												País:
												<span>{{ bookingData.customer.data.country.data.name }}</span>
											</p>
										</div>
										<div class="bar-data-item no-border">
											<v-icon class="bar-icon warning--text">start</v-icon>
											<v-btn
												icon
												@click="showCustomerData(bookingData.customer.data, true)">
												<img :src="`${$imageS3}/clerkinn/edit-icon.svg`"
													alt="">
											</v-btn>
										</div>
									</div>
								</v-flex>
								<v-flex xs12 pa-0
									v-if="!additionalCustomersIsEmpty">
									<v-layout row wrap>
										<v-flex xs12 mt-3
											v-for="(customer, customerIndex) in bookingData.customerAditional"
											:key="customer.id">
											<div class="bar-data">
												<div class="bar-data-item">
													<p>
														Huésped:
														<span>Nº {{ customerIndex + 2 }}</span>
													</p>
												</div>
												<div class="bar-data-item">
													<p>
														Nº Tarjeta:
														<span v-show="customer.cardVip">Vip</span>
														<span>-</span>
														<span v-show="customer.cardVip">{{ customer.cardVip }}</span>
													</p>
												</div>
												<div class="bar-data-item">
													<p>
														DNI:
														<span>{{ customer.numDocument }}</span>
													</p>
												</div>
												<div class="bar-data-item">
													<p>
														Nombre:
														<span>{{ customer.name }}</span>
													</p>
												</div>
												<div class="bar-data-item">
													<p>
														Apellido:
														<span>{{ customer.lastname }}</span>
													</p>
												</div>
												<div class="bar-data-item">
													<p>
														Fec. Nac.:
														<span>{{ customer.dateBirth | parseDate('DD/MM/YYYY') }}
															- {{ customer.flagPerson }}</span>
													</p>
												</div>
												<div class="bar-data-item no-border">
													<p>
														País:
														<span>{{ customer.country }}</span>
													</p>
												</div>
												<div class="bar-data-item no-border">
													<v-btn
														icon
														class="grey--text"
														@click="changeMainCustomer(customer)">
														<v-icon class="bar-icon">start</v-icon>
													</v-btn>
													<v-btn
														icon
														@click="showCustomerData(customer)">
														<img :src="`${$imageS3}/clerkinn/edit-icon.svg`"
															alt="">
													</v-btn>
													<v-btn
														icon
														class="red--text"
														:disabled="customerForm"
														@click="openDeleteCustomer(customerIndex, customer)">
														<v-icon class="bar-icon">close</v-icon>
													</v-btn>
												</div>
											</div>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 sm9 md3 mt-4>
									<button-create
										text="Agregar huésped"
										btn-function
										@function-click="showGuestForm"
										:disabled="cantAddGuest">
									</button-create>
								</v-flex>
								<v-flex xs12 sm3 md2 mt-4>
									<v-radio-group
										class="radio-group-transparent"
										v-model="personType"
										row>
										<v-radio
											:disabled="customerForm"
											label="Adulto"
											:value="1" ></v-radio>
										<v-radio
											:disabled="customerForm"
											label="Niño(a)"
											:value="2"></v-radio>
									</v-radio-group>
								</v-flex>
								<v-flex xs12 my-3>
									<v-divider></v-divider>
								</v-flex>
								<v-flex xs12 text-xs-left mb-2
									v-show="customerForm">
									<label class="label-title">Completa los datos</label>
								</v-flex>
								<v-flex xs12 text-xs-left
									v-show="customerForm">
									<v-layout row wrap v-show="isAnAdult">
										<v-flex xs12 text-xs-left>
											<label class="label-form">Nº de Tarjeta</label>
										</v-flex>
										<v-flex xs3>
											<v-select
												class="filter-select filter-select-indicator"
												item-text="name"
												item-value="id"
												:items="typeCards"
												v-model="typeCard"
												hide-details
												single-line
												bottom>
											</v-select>
											<v-text-field
												type="text"
												class="input-border-inset input-form-select"
												v-model="model.cardVip">
											</v-text-field>
										</v-flex>
									</v-layout>
									<v-layout row wrap>
										<v-flex xs3 mb-3>
											<label class="label-form">Tipo de identificación</label>
											<v-select
												class="filter-select filter-select-indicator"
												item-text="name"
												item-value="id"
												:items="typeDocuments"
												v-model="model.documentType"
												hide-details
												single-line
												bottom>
											</v-select>
											<v-text-field
												type="text"
												class="input-border-inset input-form-select"
												@blur="searchCustomer"
												v-model="model.numDocument">
											</v-text-field>
											<span class="caption red--text"
												v-if="$v.model.numDocument && $v.model.numDocument.$invalid">
												El número de documento es requerido
											</span>
											<p class="caption red--text mb-0"
												v-if="$v.model.numDocument && $v.model.numDocument.$invalid
													&& $v.model.numDocument.$params.minLength">
												Es necesario ingresar {{ $v.model.numDocument.$params.minLength.min }} dígitos
											</p>
										</v-flex>
										<v-flex xs3 mb-3 :class="{ 'xs6' : !isNaturalPersonModel }">
											<label class="label-form">{{ nameModelLabel }}</label>
											<v-text-field
												type="text"
												class="input-border-inset"
												:disabled="!model.numDocument"
												v-model="model.name">
											</v-text-field>
											<span class="caption red--text"
												v-if="$v.model.name && $v.model.name.$invalid">
												{{ nameModelMessage }}
											</span>
										</v-flex>
										<v-flex xs3 mb-3 v-if="isNaturalPersonModel">
											<label class="label-form">Apellidos</label>
											<v-text-field
												type="text"
												class="input-border-inset"
												placeholder="Completos"
												:disabled="!model.numDocument"
												v-model="model.lastname">
											</v-text-field>
											<span class="caption red--text"
												v-if="$v.model.lastname && $v.model.lastname.$invalid">
												El apellido es requerido
											</span>
										</v-flex>
										<v-flex xs3 mb-3
											v-show="isAnAdult">
											<label class="label-form">Correo electrónico</label>
											<v-text-field
												type="email"
												class="input-border-inset"
												placeholder="nombre@mail.com"
												:disabled="!model.numDocument"
												v-model="model.email">
											</v-text-field>
											<span class="caption red--text"
												v-if="$v.model.email && $v.model.email.$invalid">
												El correo es requerido
											</span>
										</v-flex>
										<v-flex xs3 mb-3>
											<label class="label-form">Fecha de nacimiento</label>
											<v-layout row wrap>
												<v-flex xs4 pa-0>
													<v-text-field
														class="input-regular input-label-select"
														:value="personTypeName"
														hide-details
														readonly>
													</v-text-field>
												</v-flex>
												<v-flex xs8 pa-0>
													<v-menu
														lazy
														v-model="menuBirthDate"
														transition="scale-transition"
														offset-y
														full-width
														class="menu-date-picker"
														:disabled="!model.numDocument"
														max-width="290px"
														v-on:input="changeIcon">
														<v-text-field
															slot="activator"
															label="Fecha de nacimiento"
															v-model="model.dateBirth"
															:append-icon="arrowIconBirth"
															:append-icon-cb="toggleIconBirthDate"
															single-line
															hide-details
															readonly
														></v-text-field>
														<v-date-picker
															:allowed-dates="datesDisabled"
															v-model="model.dateBirth"
															locale="es-PE"
															year-icon
															scrollable>
														</v-date-picker>
													</v-menu>
												</v-flex>
											</v-layout>
										</v-flex>
										<v-flex xs3 mb-3
											v-show="isAnAdult && isNaturalPersonModel">
											<label class="label-form">Estado civil</label>
											<v-select
												class="filter-select"
												item-text="name"
												item-value="id"
												:items="civilStatus"
												v-model="model.civilStatus"
												hide-details
												:disabled="!model.numDocument"
												single-line
												bottom>
											</v-select>
										</v-flex>
										<v-flex xs3 mb-3 v-if="isNaturalPersonModel">
											<label class="label-form">Género</label>
											<v-select
												class="filter-select"
												item-text="name"
												item-value="id"
												:items="genders"
												v-model="model.gender"
												hide-details
												:disabled="!model.numDocument"
												single-line
												bottom>
											</v-select>
										</v-flex>
										<v-flex xs3>
											<label class="label-form">País</label>
											<v-select
												class="filter-select"
												:items="countries"
												item-text="name"
												item-value="id"
												v-model="model.countryId"
												hide-details
												:disabled="!model.numDocument"
												single-line
												@input="loadCities"
												bottom>
											</v-select>
											<span class="caption red--text"
												v-if="$v.model.countryId && $v.model.countryId.$invalid">
												El país es requerido
											</span>
										</v-flex>
										<v-flex xs3
											v-show="isAnAdult">
											<label class="label-form">Ciudad</label>
											<v-select
												class="filter-select"
												:items="cities"
												item-text="province"
												item-value="id"
												v-model="model.cityId"
												hide-details
												:disabled="!model.numDocument"
												single-line
												bottom>
											</v-select>
										</v-flex>
										<v-flex xs3 mb-3
											v-show="isAnAdult">
											<label class="label-form">Dirección</label>
											<v-text-field
												type="text"
												class="input-border-inset"
												:disabled="!model.numDocument"
												v-model="model.address">
											</v-text-field>
										</v-flex>
										<v-flex xs3 mb-3
											v-show="isAnAdult">
											<label class="label-form">Teléfono</label>
											<v-text-field
												type="number"
												class="input-border-inset"
												:disabled="!model.numDocument"
												v-model="model.phone">
											</v-text-field>
										</v-flex>
										<v-flex xs3 mb-3>
											<v-layout row wrap
												justify-end
												class="col-without-label">
												<v-flex xs5>
													<v-btn
														class="btn-action btn-cancel white--text"
														@click="cancelAddGuest">
														Cancelar
													</v-btn>
												</v-flex>
												<v-flex xs5>
													<v-btn
														class="btn-action btn-save white--text"
														@click="addGuest"
														:disabled="addGuestDisabled">
														{{ customerBtnText }}
													</v-btn>
												</v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
									<v-layout row wrap>
										<v-flex xs12>
											<v-divider></v-divider>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 text-xs-left mb-2
									v-show="bookingData.channel.data.name">
									<label class="label-title">
										Datos de {{ bookingData.channel.data.name }}
									</label>
								</v-flex>
								<v-flex xs12 v-show="channelHasProperties">
									<div class="bar-data">
										<div
											v-for="(value, key) in bookingData.channel.data.questions"
											:key="key"
											class="bar-data-item">
											<p>
												{{ key }}:
												<span>{{ value }}</span>
											</p>
										</div>
										<div class="bar-data-item">
											<v-btn
												icon
												@click="showChannelData">
												<img :src="`${$imageS3}/clerkinn/edit-icon.svg`"
													alt="">
											</v-btn>
										</div>
									</div>
									<v-layout row wrap mt-3
										v-if="showChannelForm">
										<v-flex xs3
											v-for="(field, fieldIndex) in bookingData.channel.data.inputInformations"
											:key="fieldIndex"
											text-xs-left>
											<label class="label-form">{{ field.label }}</label>
											<component
												:is="field.type"
												:item-text="field.items.itemText"
												:item-value="field.items.itemValue"
												:items="field.items.name"
												:class="{ 'filter-select': field.type === 'v-select',
													'input-border-inset': field.type === 'v-text-field' }"
												v-model="field[field.value]">
											</component>
										</v-flex>
										<v-flex xs12 text-xs-right>
											<v-btn
												class="btn-action btn-cancel grey white--text"
												@click="cancelUpdateChannel">
												Cancelar
											</v-btn>
											<v-btn
												class="btn-action btn-save white--text ml-2"
												@click="updateChannel">
												Guardar
											</v-btn>
										</v-flex>
									</v-layout>
									<v-layout row wrap mt-3>
										<v-flex xs12>
											<v-divider></v-divider>
										</v-flex>
									</v-layout>
								</v-flex>
									<v-flex xs12>
										<v-layout row justify-end>
											<v-flex xs2>
												<v-btn
													v-if="(bookingData.bookingState === '2' || bookingData.bookingState === '7') && !lateCheckOutDisabled"
													primary
													type="button"
													class="btn-action back"
													:disabled="!lateCheckOut || disabledUpdateCheckOut"
													@click="updateCheckOut">
													Actualizar Check Out
												</v-btn>
											</v-flex>
										</v-layout>	
									</v-flex>
								<v-flex xs8>
									<v-layout row wrap
										text-xs-left>
										<v-flex xs4>
											<label class="label-text">Late Check Out</label>
										</v-flex>
										<v-flex xs4>
											<label class="label-text">Late Check Out</label>
										</v-flex>
										<v-flex xs4>
											<label class="label-text">Late Check Out</label>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs4
									v-if="lateCheckOutIsSelected">
									<v-layout row wrap
										text-xs-left>
										<v-flex xs6>
											<label class="label-form">Hora</label>
										</v-flex>
										<v-flex xs6>
											<label class="label-form">Precio</label>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs8>
									<v-radio-group
										v-model="lateCheckOut"
										class="radio-check-group"
										row>
										<v-radio
											v-for="late in arrayLate"
											:key="late.id"
											:disabled="lateCheckOutDisabled"
											:label="`${late.hour} - $${late.price}`"
											:value="late"
										>
										</v-radio>
									</v-radio-group>
								</v-flex>
								<v-flex xs4
									v-if="lateCheckOutIsSelected">
									<v-layout row wrap>
										<v-flex xs6>
											<v-text-field
												type="text"
												class="input-border-inset"
												:readonly="lateCheckOutDisabled"
												v-model="lateCheckOut.hour">
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												type="text"
												class="input-border-inset"
												:readonly="lateCheckOutDisabled"
												v-model="lateCheckOut.price">
											</v-text-field>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs8>
									<v-layout row wrap
										text-xs-left>
										<v-flex xs4>
											<label class="label-text">Early Check In</label>
										</v-flex>
										<v-flex xs4>
											<label class="label-text">Early Check In</label>
										</v-flex>
										<v-flex xs4>
											<label class="label-text">Early Check In</label>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs4
									v-if="earlyCheckInIsSelected">
									<v-layout row wrap
										text-xs-left>
										<v-flex xs6>
											<label class="label-form">Hora</label>
										</v-flex>
										<v-flex xs6>
											<label class="label-form">Precio</label>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs8>
									<v-radio-group
										v-model="earlyCheckin"
										class="radio-check-group"
										row>
										<v-radio
											v-for="early in arrayEarly"
											:key="early.id"
											:disabled="bookingData.bookingState === '2'"
											:label="`${early.hour} - $${early.price}`"
											:value="early"
										>
										</v-radio>
									</v-radio-group>
								</v-flex>
								<v-flex xs4
									v-if="earlyCheckInIsSelected">
									<v-layout row wrap>
										<v-flex xs6>
											<v-text-field
												type="text"
												class="input-border-inset"
												:readonly="earlyCheckinDisabled"
												v-model="earlyCheckin.hour">
											</v-text-field>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												type="text"
												class="input-border-inset"
												:readonly="earlyCheckinDisabled"
												v-model="earlyCheckin.price">
											</v-text-field>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs8 text-xs-left>
									<v-flex xs8>
										<button-field
											label-text="Cama adicional"
											:activated-button="bedSelected"
											v-model="aditionalBedPrice"
											@activate-button="selectBed"
										/>
									</v-flex>
								</v-flex>
								<v-flex xs8 text-xs-left>
									<v-flex xs8>
										<button-field
											label-text="Cuna"
											:activated-button="cribSelected"
											v-model="cribPrice"
											@activate-button="selectCrib"
										/>
									</v-flex>
								</v-flex>
								<v-flex xs12 text-xs-left>
									<label class="label-form">Observaciones Adicionales</label>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										class="input-border-inset input-textarea input-note mt-1"
										no-resize
										multi-line
										placeholder="Escriba aquí"
										:rows="7"
										v-model="bookingData.summary.personalInformation.specialRequest"
										textarea
									></v-text-field>
								</v-flex>
							</v-layout>
							<v-layout row wrap align-center
								v-else-if="i === 2" my-4>
								<v-flex xs9>
									<v-layout row wrap align-center>
										<v-flex xs2
											v-for="category in localCategories"
											:key="category.id"
											class="filter-list">
											<v-btn
												class="mr-0"
												:class="{'active': category.id === categoryValue}"
												:disabled="loading"
												@click="selectCategory(category.id)"
											>
												{{ category.name }}
											</v-btn>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 my-2>
									<v-divider></v-divider>
								</v-flex>
								<v-flex xs12>
									<v-layout row justify-end>
										<v-flex xs2 class="container-flex">
											<label>
												Monto Abonado
											</label>
											<v-text-field
												type="text"
												class="input-border-inset inline"
												:disabled="true"
												v-model="summaryData.documentsAmountPayment"
											>
											</v-text-field>					
										</v-flex>
										<v-flex xs2 class="container-flex">
											<label>
												Monto Pendiente
											</label>
											<v-text-field
												type="text"
												class="input-border-inset inline"
												:disabled="true"
												v-model="summaryData.documentsPendingAmount"
											>
											</v-text-field>					
										</v-flex>
										<v-flex xs2 class="container-flex">
											<label>
												Total
											</label>
											<v-text-field
												type="text"
												class="input-border-inset inline"
												:disabled="true"
												v-model="summaryData.documentsAmount"
											>
											</v-text-field>					
										</v-flex>		
									</v-layout>
								</v-flex>
								<v-flex xs12>
									<p class="title-form">Filtro</p>
								</v-flex>
								<v-flex xs3 text-xs-left pt-0>
									<v-menu
										lazy
										v-model="menuProduct"
										transition="scale-transition"
										offset-y
										full-width
										class="menu-date-picker"
										:nudge-left="40"
										max-width="290px"
										v-on:input="changeIconProduct">
										<v-text-field
											slot="activator"
											label="Fecha de creación"
											v-model="createdAt"
											class="product-date-picker"
											prepend-icon="event"
											:append-icon="arrowIconProduct"
											:append-icon-cb="toggleIconProductDate"
											single-line
											hide-details
											readonly
										></v-text-field>
										<v-date-picker
											v-model="createdAt"
											no-title
											scrollable>
										</v-date-picker>
									</v-menu>
								</v-flex>
								<v-flex xs1 text-xs-left pt-0>
									<v-btn
										type="button"
										class="btn-success white--text"
										@click="filterSummary">
										<v-icon>filter_list</v-icon>
									</v-btn>
								</v-flex>
								<v-flex xs8>
									<v-layout row wrap align-center justify-end>
										<v-flex xs3>
											<v-btn
												type="button"
												class="btn-action btn-success white--text"
												@click="downloadSale">
												<v-icon>print</v-icon>
												Imprimir Resumen
											</v-btn>
										</v-flex>
										<v-flex xs3>
											<v-btn
												type="button"
												class="btn-action btn-success white--text"
												:disabled="Number(bookingData.bookingState) === 3"
												@click.native.stop="openProductsModal">
												<v-icon>add</v-icon> Agregar
											</v-btn>
											<v-dialog
												v-model="dialog"
												persistent
												width="auto">
												<v-card height="auto">
													<v-card-title class="headline">
														Agregar Producto
													</v-card-title>
													<v-layout row wrap align-center>
														<v-flex xs12 mb-4>
															<v-divider></v-divider>
														</v-flex>
														<v-flex xs2 pl-3>
															<v-subheader class="pl-0">
																Almacenes
															</v-subheader>
															<v-select
																class="filter-select"
																hide-details
																item-text="name"
																item-value="id"
																:items="warehouses"
																v-model="productWarehouse"
															>
															</v-select>
														</v-flex>
														<v-flex xs2 pl-3>
															<v-subheader class="pl-0">
																Categorías
															</v-subheader>
															<v-select
																class="filter-select"
																hide-details
																item-text="name"
																item-value="id"
																:items="categories"
																v-model="productCategory"
															>
															</v-select>
														</v-flex>
														<v-flex xs1 pl-3 text-xs-left pt-5>
															<v-btn
																type="button"
																class="btn-success white--text"
																@click="filterProducts">
																<v-icon>filter_list</v-icon>
															</v-btn>
														</v-flex>
														<v-flex xs12 mt-5>
															<table-run
																:columns="productColumns"
																:rows="productRows"
																:include-delete="false"
																:include-export-to-excel="false"
																:include-options="false"
																:include-switch="false"
																:include-settings="false"
																:include-delete-single="false"
																key-value="warProductId"
																selectable
																@on-search-event="searchProductsByColumn">
																<template slot="rows" scope="props">
																	<td>{{ props.row.code }}</td>
																	<td>{{ props.row.warehouseName }}</td>
																	<td>{{ props.row.categoryName }}</td>
																	<td>{{ props.row.name }}</td>
																	<td>{{ props.row.stock }}</td>
																	<td class="px-2">
																		<v-text-field
																			type="number"
																			class="input-border-inset width-60"
																			v-model.number="props.row.quantity"
																			@keyup="positiveValue(props.row, 'quantity')">
																		</v-text-field>
																	</td>
																	<td class="text-xs-center">{{ props.row.price }}</td>
																	<td class="px-2 d-flex">
																		<v-text-field
																			type="number"
																			class="input-border-inset basis-30 mr-2"
																			v-model.number="props.row.discount"
																			@keyup="positiveValue(props.row, 'discount')">
																		</v-text-field>
																		<span class="basis-70">%</span>
																	</td>
																</template>
															</table-run>
														</v-flex>
														<v-flex xs12 text-xs-right>
															<v-pagination
																v-bind:length="totalModalPages"
																v-model="paramsSummary.page"
																:total-visible="pagesVisible"
																v-on:input="loadSummaryProducts(paramsSummary.page)">
															</v-pagination>
														</v-flex>
													</v-layout>
													<v-card-actions>
														<v-layout row wrap my-3
															align-end
															justify-center>
															<v-flex xs2 pr-2>
																<v-btn
																	type="button"
																	primary
																	class="btn-action"
																	@click.native="dialog = false">
																	Cancelar
																</v-btn>
															</v-flex>
															<v-flex xs2 pl-2>
																<v-btn
																	class="btn-action btn-success white--text"
																	:disabled="addProductsDisabled"
																	@click.native="updateProducts">
																	Guardar
																</v-btn>
															</v-flex>
														</v-layout>
													</v-card-actions>
												</v-card>
											</v-dialog>
										</v-flex>
										<v-flex xs3>
											<label class="total-amount">
												Total ${{ totalAmount | round }}
											</label>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 my-2>
									<v-divider></v-divider>
								</v-flex>
								<v-flex xs12 pb-0>
									<table-run
										:columns="summaryColumns"
										:rows="summaryRows"
										:include-delete="false"
										:include-export-to-excel="false"
										:include-options="false"
										:include-search="false"
										:include-switch="false"
										:include-settings="false"
										:include-delete-single="false">
										<template slot="rows" scope="props">
											<td>{{ props.row.createdAt | parseDate }}</td>
											<td>
												{{ props.row.createdAt | parseDate('HH:mm') }}
											</td>
											<td>
												<span v-if="props.row.product">
													{{ props.row.product.code }}
												</span>
											</td>
											<td>{{ props.row.quantity }}</td>
											<td>
												<span v-if="props.row.product">
													{{ props.row.product.name }}
												</span>
											</td>
											<td>{{ props.row.subTotal | round }}</td>
											<td>{{ props.row.salDocumentsNumber }}</td>
											<td>
												<v-flex text-xs-right>
													<button>
														<img src="/static/img/divide.png" 
															alt=""
															v-if="showAccommodationOption(props.row)"
															v-show="props.row.product.name === 'ALOJAMIENTO'"
															@click="openModal(props.row.subTotal, props.row.idDetail, props.row.product.code)"
														>
													</button>
													<v-btn
													v-if="showSummaryOption(props.row)"
													icon
													class="error--text"
													@click="deleteSummaryDetailConfirm(props.row)"
												>
													<v-icon>delete</v-icon>
												</v-btn>
												</v-flex>
											</td>
										</template>
									</table-run>
									<modal-bill
										:amountTotal="modalSubTotal"
										:id-detail="modalDetail"
										:is-visible="visibleModal"
										@close-modal="closeModal"
										@cancel-modal="cancelModal"
										@save-modal="saveModal"
									></modal-bill>
								</v-flex>
								<v-flex xs12>
									<v-layout row wrap justify-center my-3>
										<v-flex xs2 pr-2 text-xs-right>
											<v-btn
												type="button"
												class="btn-save btn-grey white--text"
												:disabled="saleDisabled"
												@click.native.stop="openSaleModal">
												{{ chargeBtnText }}
											</v-btn>
											<v-dialog
												v-model="saleModal"
												persistent
												width="850px">
												<v-card height="auto" class="pb-5">
													<v-tabs class="checkin-tabs checkin-tabs-modal" v-model="salesTabs">
														<v-tabs-bar class="transparent headline">
															<v-tabs-slider class="default-skyblue"></v-tabs-slider>
															<v-tabs-item href="#tab-sales">
																Ventas
															</v-tabs-item>
															<v-tabs-item href="#tab-customer">
																Nuevo Cliente
															</v-tabs-item>
														</v-tabs-bar>
														<v-tabs-items>
															<v-tabs-content id="tab-sales" class="pt-4">
																<v-layout row wrap align-center>
																	<v-flex xs12 px-2 v-if="alert">
																		<v-alert
																			:info="alertInfo"
																			:warning="alertWarning"
																			dismissible
																			v-model="alert"
																			class="text-xs-left">
																			{{ alertMessage }}
																		</v-alert>
																	</v-flex>
																	<v-flex xs12 mb-2 pl-2 v-if="billingActive && !cantBilling">
																		<v-checkbox
																			class="input-checkbox input-booking"
																			label="Exonerar impuestos"
																			v-model="flagTaxes"
																			color="info"
																			hide-details
																			@change="validateExoneration">
																		</v-checkbox>
																	</v-flex>
																	<v-flex xs12 mb-2>
																		<v-layout row wrap align-center>
																			<v-flex xs2>
																				<label class="label-sale-modal">Tipo de documento</label>
																			</v-flex>
																			<v-flex xs4>
																				<v-radio-group
																					v-model="saleModel.typeDocumentCode"
																					v-if="documentTypes.length > 0"
																					@change="setTypeDocument"
																					row>
																					<v-radio
																						class="sale-radio-button"
																						color="info"
																						:label="documentTypes[0].documentType.name"
																						:value="documentTypes[0].documentType.code">
																					</v-radio>
																					<v-radio
																						class="sale-radio-button"
																						color="info"
																						:disabled="cantBilling"
																						:label="documentTypes[1].documentType.name"
																						:value="documentTypes[1].documentType.code">
																					</v-radio>
																					<v-radio
																						class="sale-radio-button"
																						color="info"
																						:label="documentTypes[2].documentType.name"
																						:value="documentTypes[2].documentType.code"
																						>
																					</v-radio>
																				</v-radio-group>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-flex xs8 mb-3>
																		<v-layout wrap align-center>
																			<v-flex xs2 pl-3 text-xs-left>
																				<label class="label-sale-modal">
																					Tipo de cambio
																				</label>
																			</v-flex>
																			<v-flex xs4 pr-3>
																				<v-text-field
																					type="text"
																					class="input-border-inset"
																					v-model="exchangeRate"
																					@blur="changeAmounts(currencySelected)"
																					@keyup.enter="changeAmounts(currencySelected)">
																				</v-text-field>
																			</v-flex>
																			<v-flex xs2>
																				<v-select
																					class="filter-select"
																					item-text="code"
																					item-value="code"
																					label="Moneda"
																					:items="currencies"
																					v-model="currencySelected"
																					hide-details
																					single-line
																					bottom
																					@input="validateExoneration(flagTaxes)"
																				>
																				</v-select>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-flex xs4 mb-3>
																				<v-layout wrap justify-end align-center>
																					<v-flex xs6 text-xs-right pr-3
																						>
																						<label class="label-form">Recargo al Consumo</label>
																						<v-text-field
																							type="number"
																							class="input-border-inset"
																							v-model="tip"
																							>
																						</v-text-field>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																	<v-flex xs12 mb-3>
																		<v-layout wrap>
																			<v-flex xs4 pl-2>
																				<v-select
																					class="filter-select filter-select-indicator"
																					item-text="name"
																					item-value="id"
																					:items="typeDocuments"
																					v-model="saleData.typeDocument"
																					hide-details
																					single-line
																					bottom>
																				</v-select>
																				<v-text-field
																					type="text"
																					class="input-border-inset input-form-select"
																					@keyup.enter="searchCustomerSale"
																					@blur="searchCustomerSale"
																					v-model="saleData.numDocument">
																				</v-text-field>
																			</v-flex>
																			<v-flex xs2 pl-3>
																				<v-btn
																					class="btn-action btn-success white--text"
																					@click="addCustomer"
																				>
																					<v-icon>add</v-icon>
																					Agregar Cliente
																				</v-btn>
																			</v-flex>
																			<v-flex xs4 pl-3 offset-xs1>
																				<v-checkbox
																					class="input-checkbox input-booking"
																					label="Incluir los datos del Huésped"
																					v-model="flagShowCustomer"
																					color="info"
																					hide-details>
																				</v-checkbox>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-flex xs12 pl-2>
																		<v-layout wrap>
																			<v-flex xs2>
																				<v-select
																					class="filter-select"
																					item-text="name"
																					item-value="code"
																					label="Modo de pago"
																					:items="paymentMethods"
																					v-model="saleModel.paymentMethodCode"
																					@input="setPaymentMethod"
																					hide-details
																					single-line
																					bottom>
																				</v-select>
																			</v-flex>
																			<v-flex xs6 pl-3 pr-2 v-if="!creditPayment">
																				<v-select
																					chips
																					class="filter-select filter-select-multiple"
																					hide-details
																					item-text="name"
																					item-value="code"
																					:disabled="invalid || invalidBol"
																					:items="typePayments"
																					label="Selecciona los tipos de pago a realizar"
																					multiple
																					return-object
																					single-line
																					v-model="typePaymentsSelected"
																					@input="addPays"
																					@click="openModal"
																				>
																				</v-select>
																			</v-flex>
																			<v-flex xs3 px-3 v-else>
																				<v-select
																					class="filter-select"
																					hide-details
																					:disabled="invalid || invalidBol"
																					:items="numberDays"
																					label="# Días"
																					single-line
																					v-model="paymentDays"
																				>
																				</v-select>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-flex xs12 px-3 mt-3>
																		<v-layout wrap>
																			<v-flex xs2 text-xs-left pr-2
																				v-for="pay in paysByTypePayment"
																				:key="pay.code"
																			>
																				<label class="label-form">{{ pay.name }}</label>
																				<v-text-field
																					type="number"
																					class="input-border-inset"
																					v-model.number="pay.amount">
																				</v-text-field>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-flex xs12 mt-3>
																		<div class="bar-data">
																			<div class="bar-data-item">
																				<p>
																					Cliente:
																					<span>{{ saleCustomer.name }}</span>
																				</p>
																			</div>
																			<div class="bar-data-item">
																				<p>
																					{{ documentTypeName }}:
																					<span>{{ saleCustomer.document }}</span>
																				</p>
																			</div>
																			<div class="bar-data-item">
																				<p>
																					Tipo de Documento:
																					<span>{{ saleCustomer.typeDocument }}</span>
																				</p>
																			</div>
																			<div class="bar-data-item">
																				<p>
																					Moneda:
																					<span>{{ currencySelected }}</span>
																				</p>
																			</div>
																		</div>
																	</v-flex>
																	<v-flex xs12 mt-3>
																		<table-run
																			class="no-selectable-table width-auto"
																			ref="saleTable"
																			:columns="localProductsColumns"
																			:rows="newLocalProductsRows"
																			:include-delete="false"
																			:include-export-to-excel="false"
																			:include-options="false"
																			:include-search="false"
																			:include-switch="false"
																			:include-settings="false"
																			:include-delete-single="false"
																			:selectable="false">
																			<template slot="rows" scope="props">
																				<td>{{ props.row.createdAt | parseDate }}</td>
																				<td>{{ props.row.product.code }}</td>
																				<td>{{ props.row.product.category.name }}</td>
																				<td>{{ props.row.product.name }}</td>
																				<td>{{ props.row.quantity }}</td>
																				<td>
																					{{ symbol }} <input class="input-edit" type="number" v-model="props.row.price" maxlength="4" pattern="\d{2}" required>
																					<!-- {{ props.row.price | round | currency(symbol) }} -->
																					<v-btn
																						icon
																						class="warning--text"
																						v-if="props.row.product.flagIgvRequired"
																						v-tooltip:top="{ html: 'Impuesto obligatorio' }"
																					>
																						<v-icon>
																							warning
																						</v-icon>
																					</v-btn>
																					<v-btn
																						icon
																						class="warning--text"
																						v-if="igvExonerated(props.row)"
																						v-tooltip:top="{ html: 'Impuesto exonerado' }"
																					>
																						<v-icon>
																							warning
																						</v-icon>
																					</v-btn>
																				</td>
																				<td>{{ props.row.discountPercentage }}%</td>
																			</template>
																		</table-run>
																	</v-flex>
																</v-layout>
																<v-layout wrap mt-2>
																	<v-flex xs12 px-3 text-xs-left>
																		<label>Observación:</label>
																		<v-text-field
																			class="input-border-inset input-textarea input-note mt-1"
																			no-resize
																			multi-line
																			placeholder="Escriba aquí"
																			:rows="2"
																			textarea
																			v-model="commentary"
																		></v-text-field>
																	</v-flex>
																</v-layout>
																<v-layout wrap align-end justify-center mt-5>
																	<v-flex xs2 pr-2>
																		<v-btn
																			type="button"
																			primary
																			class="btn-action"
																			@click.native="saleModal = false">
																			Cancelar
																		</v-btn>
																	</v-flex>
																	<v-flex xs2 pl-2>
																		<v-btn
																			class="btn-action btn-success white--text"
																			:disabled="$v.saleCustomer.$invalid
																				|| disableGenerateSale || validateAmount
																				|| invalid || disabledSave || $v.paymentDays.$invalid
																				|| invalidBol"
																			@click.native="generateSale">
																			Guardar
																		</v-btn>
																	</v-flex>
																	<v-flex xs2 pl-3>
																		<v-btn class="btn-action back btn-blue"
																		@click.native="postPreview"
																		:disabled="$v.saleCustomer.$invalid
																		|| validateAmount"
																		>
																			Previsualización
																		</v-btn>
																	</v-flex>
																</v-layout>
															</v-tabs-content>
															<v-tabs-content id="tab-customer" class="pt-4">
																<v-layout row wrap align-center>
																	<v-flex xs12 px-3>
																		<v-layout wrap text-xs-left>
																			<v-flex xs4 mb-3 pr-3>
																				<label class="label-form">Tipo de identificación</label>
																				<v-select
																					class="filter-select filter-select-indicator"
																					item-text="name"
																					item-value="id"
																					:items="typeDocuments"
																					v-model="newCustomerSale.documentType"
																					hide-details
																					single-line
																					bottom>
																				</v-select>
																				<v-text-field
																					type="text"
																					class="input-border-inset input-form-select"
																					v-model="newCustomerSale.numDocument"
																					@blur="searchCustomerNew">
																				</v-text-field>
																				<span class="caption red--text"
																					v-if="$v.newCustomerSale.numDocument
																						&& $v.newCustomerSale.numDocument.$invalid">
																					El número de documento es requerido
																				</span>
																				<p class="caption red--text mb-0"
																					v-if="$v.newCustomerSale.numDocument &&
																						$v.newCustomerSale.numDocument.$invalid
																						&& $v.newCustomerSale.numDocument.$params.minLength">
																					Es necesario ingresar {{ $v.newCustomerSale.numDocument.$params.minLength.min }} dígitos
																				</p>
																			</v-flex>
																			<v-flex xs4 mb-3 pr-3 :class="{ 'xs8' : !isNaturalPerson }">
																				<label class="label-form">{{ nameLabel }}</label>
																				<v-text-field
																					type="text"
																					class="input-border-inset"
																					v-model="newCustomerSale.name">
																				</v-text-field>
																				<span class="caption red--text"
																					v-if="$v.newCustomerSale.name
																						&& $v.newCustomerSale.name.$invalid">
																					{{ nameValidateMessage }}
																				</span>
																			</v-flex>
																			<v-flex xs4 mb-3 v-if="isNaturalPerson">
																				<label class="label-form">Apellidos</label>
																				<v-text-field
																					type="text"
																					class="input-border-inset"
																					placeholder="Completos"
																					v-model="newCustomerSale.lastname">
																				</v-text-field>
																				<span class="caption red--text"
																					v-if="$v.newCustomerSale.lastname
																						&& $v.newCustomerSale.lastname.$invalid">
																					El apellido es requerido
																				</span>
																			</v-flex>
																			<v-flex xs4 mb-3 pr-3>
																				<label class="label-form">Correo electrónico</label>
																				<v-text-field
																					type="email"
																					class="input-border-inset"
																					placeholder="nombre@mail.com"
																					v-model="newCustomerSale.email">
																				</v-text-field>
																				<span class="caption red--text"
																					v-if="$v.newCustomerSale.email
																						&& $v.newCustomerSale.email.$invalid">
																					El correo es requerido
																				</span>
																			</v-flex>
																			<v-flex xs8 mb-3>
																				<label class="label-form">Dirección</label>
																				<v-text-field
																					type="text"
																					class="input-border-inset"
																					v-model="newCustomerSale.address">
																				</v-text-field>
																				<span class="caption red--text"
																					v-if="$v.newCustomerSale.address
																						&& $v.newCustomerSale.address.$invalid">
																					La dirección es requerida
																				</span>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
																<v-layout row wrap my-3
																	align-end
																	justify-center>
																	<v-flex xs2 pr-2>
																		<v-btn
																			type="button"
																			primary
																			class="btn-action"
																			@click.native="backToSales">
																			Cancelar
																		</v-btn>
																	</v-flex>
																	<v-flex xs2 pl-2>
																		<v-btn
																			class="btn-action btn-success white--text"
																			:disabled="$v.newCustomerSale.$invalid"
																			@click.native="saveCustomer">
																			Registrar
																		</v-btn>
																	</v-flex>
																</v-layout>
															</v-tabs-content>
														</v-tabs-items>
													</v-tabs>
												</v-card>
											</v-dialog>
										</v-flex>
										<v-flex xs2 pl-2 text-xs-left>
											<v-btn
												type="button"
												class="btn-save white--text"
												:disabled="checkoutDisabled"
												@click="checkout">
												Check out
											</v-btn>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
							<v-layout row wrap
								v-else-if="i === 3" mt-4>
								<v-flex xs12 mb-5>
									<v-layout row wrap align-center>
										<v-flex xs10>
											<v-layout row wrap align-center>
												<v-flex xs3
													v-for="filter in filters"
													:key="filter.id"
													class="filter-list">
													<v-btn
														:class="{'active': filter.id === filterValue}"
														v-on:click="selectFilter(filter.id)"
														:disabled="loading">
														{{ filter.label }}
														(<span v-if="filter.id === 1">{{ quantityNotes.activeNotes }}</span>
														<span v-else>{{ quantityNotes.filedNotes }}</span>)
													</v-btn>
												</v-flex>
											</v-layout>
										</v-flex>
										<v-flex xs2>
											<v-btn
												type="button"
												v-on:click="addNotes"
												class="btn-save btn-success">
												<v-icon>add</v-icon>
												Agregar
											</v-btn>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 mb-2 v-if="inputNote">
									<form v-on:submit.prevent="saveNote">
										<v-layout row wrap>
											<v-flex xs12 mb-2>
												<v-text-field
													class="input-textarea input-note"
													placeholder="Añada notas aquí, pulse 'Enter' para guardar"
													no-resize
													multi-line
													:rows="7"
													v-model="note"
													v-on:keyup.enter="saveNote"
													textarea
												></v-text-field>
											</v-flex>
											<v-flex xs12 mt-2 text-xs-right>
												<v-btn
													type="submit"
													class="btn-save">
													{{ actionNoteButton }}
												</v-btn>
											</v-flex>
										</v-layout>
									</form>
								</v-flex>
								<v-flex xs12>
									<table-run
										:columns="notesColumns"
										:rows="notesRows"
										:include-delete="false"
										:include-export-to-excel="false"
										:include-options="false"
										:include-search="false"
										:include-switch="false"
										:include-settings="false"
										:include-delete-single="false"
										:selectable="false"
										@on-sortable-event="notesColumnSortableEvent"
										class="no-selectable-table">
										<template slot="rows" scope="props">
											<td>Nota {{ props.row.id }} ({{ props.row.note }})</td>
											<td class="text-xs-right">
												<v-btn
													icon
													@click="saveNote(props.row)"
													v-if="filterValue === 1">
													<img
														:src="`${$imageS3}/housekeeping/archive.svg`"
														alt="">
												</v-btn>
												<v-btn
													v-else
													icon
													@click="saveNote(props.row)">
													<img
														:src="`${$imageS3}/housekeeping/unarchive.svg`"
														alt="">
												</v-btn>
												<v-btn
													v-if="filterValue === 1"
													icon
													@click="updateNote(props.row, 1)">
													<img
														:src="`${$imageS3}/housekeeping/edit.svg`"
														alt="">
												</v-btn>
												<v-btn
													icon
													@click.native.stop="openDeleteConfirm(props.row.id)">
													<img
														:src="`${$imageS3}/housekeeping/delete.svg`"
														alt="">
												</v-btn>
											</td>
										</template>
									</table-run>
								</v-flex>
								<v-flex xs12 text-xs-right mb-5>
									<v-pagination
										v-bind:length="totalNotesPages"
										v-model="paramsNotes.page"
										:total-visible="notesPagesVisible"
										v-on:input="loadNotes(paramsNotes.page)">
									</v-pagination>
								</v-flex>
							</v-layout>
							<v-layout row wrap
								v-else-if="i === 4" my-4>
								<v-flex xs12>
									<p class="title-form">Filtro</p>
								</v-flex>
								<v-flex xs12>
									<v-layout row wrap align-center mb-3>
										<v-flex md5 my-1>
											<v-layout row wrap align-center class="calendar-range">
												<v-flex md6 pa-0>
													<v-menu
														lazy
														v-model="menu"
														transition="scale-transition"
														offset-y
														full-width
														class="menu-date-picker"
														:nudge-left="40"
														max-width="290px"
														v-on:input="changeIconStart">
														<v-text-field
															slot="activator"
															label="Fecha inicial"
															class="product-date-picker"
															v-model="startDate"
															prepend-icon="event"
															:append-icon="arrowIconStart"
															:append-icon-cb="toggleIconStartDate"
															single-line
															hide-details
															readonly
														></v-text-field>
														<v-date-picker
															v-model="startDate"
															no-title
															scrollable>
														</v-date-picker>
													</v-menu>
												</v-flex>
												<v-flex md6 pa-0>
													<v-menu
														lazy
														v-model="menuEnd"
														transition="scale-transition"
														offset-y
														full-width
														class="menu-date-picker"
														:nudge-left="40"
														max-width="290px"
														v-on:input="changeEndIcon">
														<v-text-field
															slot="activator"
															label="Fecha final"
															v-model="endDate"
															:append-icon="arrowIconEnd"
															:append-icon-cb="toggleIconEndDate"
															single-line
															hide-details
															readonly
														></v-text-field>
														<v-date-picker
															v-model="endDate"
															no-title
															scrollable>
														</v-date-picker>
													</v-menu>
												</v-flex>
											</v-layout>
										</v-flex>
										<v-flex md1 pr-5>
											<v-btn
												type="button"
												class="btn-action btn-success white--text"
												:disabled="!startDate || !endDate"
												@click="filterBookings">
												<v-icon>filter_list</v-icon>
											</v-btn>
										</v-flex>
									</v-layout>
								</v-flex>
								<table-run
									:columns="columns"
									:rows="rows"
									:include-delete="false"
									:include-export-to-excel="false"
									:include-options="true"
									:include-settings="false"
									:include-delete-single="false"
									:selectable="false"
									@on-sortable-event="columnSortableEvent"
									@on-search-event="searchByColumn"
									class="no-selectable-table">
									<template slot="rows" scope="props">
										<td>{{ props.row.code }}</td>
										<td>
											{{ props.row.codeRoomtype }}
											{{ props.row.room.data.codeRoom }}
										</td>
										<td>
											{{ props.row.customer.data.name }}
											{{ props.row.customer.data.lastname }}
										</td>
										<td>
											{{ props.row.bookingStart | parseDate }} - {{ props.row.bookingEnd | parseDate }}
										</td>
										<td>{{ props.row.guests }}</td>
										<td>{{ props.row.numberNights }}</td>
										<td>{{ props.row.summary.promotion.currency }} {{ props.row.total | round }}</td>
										<td class="text-xs-center">
											<v-btn
												icon
												class="success--text"
												@click="downloadSale(props.row.room.data)">
												<v-icon>file_download</v-icon>
											</v-btn>
										</td>
									</template>
								</table-run>
								<v-flex xs12 text-xs-right>
									<v-pagination
										v-bind:length="totalHistoryPages"
										v-model="paramsBookingHistory.page"
										:total-visible="pagesVisibleHistory"
										v-on:input="loadBookingHistory(paramsBookingHistory.page)">
									</v-pagination>
								</v-flex>
							</v-layout>
							<v-layout row wrap mt-4
								v-else-if="i === 5" >
								<table-run
									:columns="emailColumns"
									:rows="emailRows"
									:include-search="false"
									:include-delete="false"
									:include-export-to-excel="false"
									:include-options="false"
									:include-settings="false"
									:include-delete-single="false"
									:selectable="false"
									class="no-selectable-table no-search-table">
									<template slot="rows" scope="props">
										<td>{{ props.row.sentDate | parseDate('DD-MM-YYYY') }}</td>
										<td>
											<span v-if="props.row.data">
												{{ props.row.data.from }}
											</span>
										</td>
										<td>
											<span v-if="props.row.data">
												{{ props.row.data.to }}
											</span>
										</td>
										<td>
											<span v-if="props.row.data">
												{{ props.row.data.message }}
											</span>
										</td>
										<td>
											<v-btn
												icon
												class="success--text"
												@click.prevent="previewEmail(props.row)">
												<v-icon>visibility</v-icon>
											</v-btn>
										</td>
									</template>
								</table-run>
								<v-flex xs12 text-xs-right mb-5>
									<v-pagination
										v-bind:length="emailPages"
										v-model="emailParams.page"
										:total-visible="emailVisiblePages"
										v-on:input="loadEmails(emailParams.page)">
									</v-pagination>
								</v-flex>
							</v-layout>
							<v-layout row wrap my-4
								v-else>
								<table-run
									:columns="billingColumns"
									:rows="billingRows"
									:include-search="false"
									:include-delete="false"
									:include-export-to-excel="false"
									:include-options="false"
									:include-settings="false"
									:include-delete-single="false"
									:selectable="false"
									class="no-selectable-table no-search-table">
									<template slot="rows" scope="props">
										<td>{{ props.row.serie }}-{{ props.row.number }}</td>
										<td>{{ getTypeDocumentName(props.row) }}</td>
										<td>{{ props.row.createdAt | parseDate }}</td>
										<td>
											{{ props.row.stateName }}
											<v-btn
												class="error-icon"
												icon
												v-if="props.row.showCanceled"
												v-tooltip:top="{ html: 'Factura Anulada' }"
											>
												<v-icon>block</v-icon>
											</v-btn>
										</td>
										<td>
											<v-btn
												icon
												class="info--text"
												v-tooltip:top="{ html: 'Pagar' }"
												v-if="!props.row.flagAmountTotal
													&& props.row.showCancel"
												@click.native.prevent="openBillingPay(props.row)">
												<v-icon>payment</v-icon>
											</v-btn>
											<v-btn
												icon
												class="success--text"
												v-tooltip:top="{ html: 'Ver detalle' }"
												@click.native.prevent="openBillingDetail(props.row)">
												<v-icon>visibility</v-icon>
											</v-btn>
											<v-btn
												v-if="props.row.showPrintCot"
												icon
												v-tooltip:top="{ html: 'Imprimir Comanda' }"
												@click.native.prevent="downLoadUniqueTicket(props.row)">
												<v-icon>print</v-icon>
											</v-btn>
										</td>
									</template>
								</table-run>
							</v-layout>
						</v-tabs-content>
					</v-tabs-items>
				</v-tabs>
			</v-flex>
			<v-dialog
				v-model="dialogNote"
				persistent
				width="auto">
				<v-card>
					<v-card-title class="headline">
						¿Desea eliminar la nota {{ noteId }}?</v-card-title>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							class="green--text darken-1"
							flat="flat"
							@click.native="cancelDeleteNote">
							Cancelar
						</v-btn>
						<v-btn
							class="green--text darken-1"
							flat="flat"
							@click.native="deleteNote">
							Eliminar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogCustomer"
				persistent
				width="auto">
				<v-card>
					<v-card-title class="headline">
						¿Desea eliminar al huésped {{ customerNumber }}?</v-card-title>
					<v-card-actions>
						<v-layout row wrap justify-end>
							<v-flex xs5 pr-1>
								<v-btn
									class="white--text darken-1"
									info
									@click.native="cancelDeleteCustomer">
									Cancelar
								</v-btn>
							</v-flex>
							<v-flex xs5 pl-1>
								<v-btn
									class="white--text darken-1"
									error
									@click.native="deleteCustomer">
									Eliminar
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogBillingDetail"
				persistent
				width="600">
				<v-card>
					<v-card-title class="headline">
						Detalle de Factura
					</v-card-title>
					<table-run
						:columns="billingDetailsColumns"
						:rows="billingDetails"
						:include-search="false"
						:include-delete="false"
						:include-export-to-excel="false"
						:include-options="false"
						:include-settings="false"
						:include-delete-single="false"
						:selectable="false"
						class="no-selectable-table no-search-table">
						<template slot="rows" scope="props">
							<td>{{ props.row.documentId }}</td>
							<td>{{ props.row.expirationDate | parseDate }}</td>
							<td>{{ props.row.amount | round | currency(symbol) }}</td>
							<td>{{ props.row.amountPayment | round | currency(symbol) }}</td>
							<td>{{ props.row.amountToPay | round | currency(symbol) }}</td>
						</template>
					</table-run>
					<v-card-actions class="mt-3">
						<v-layout row wrap justify-center>
							<v-flex xs3 pr-1>
								<v-btn
									class="white--text darken-1"
									info
									@click.native="closeBillingDialog">
									Cerrar
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogBillingPay"
				persistent
				width="650">
				<v-card>
					<v-card-title class="headline">
						Pagar Factura
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout wrap mb-3>
							<v-flex xs6 text-xs-left>
								<v-subheader class="title black--text px-0">
									Nº DOC: {{ billingDetail.documentId }}
								</v-subheader>
								<p class="my-0 grey--text">
									El adelanto se realizó en moneda {{ currencySelected }}
								</p>
							</v-flex>
							<v-flex xs3>
								<v-btn
									class="white--text darken-1"
									success
									@click.native="goToBill(billingDetail.documentId)">
									Ver Detalle de Factura
								</v-btn>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<v-flex xs12 sm4 mr-3 text-xs-left>
								<label class="label-form">Tipo de pago</label>
								<v-select
									class="filter-select"
									item-text="name"
									item-value="code"
									:items="typePayments"
									v-model="billingTypePaymentCode"
									hide-details
								>
								</v-select>
							</v-flex>
							<v-flex xs12 sm4 text-xs-left>
								<label class="label-form">Cuenta Bancaria</label>
								<v-select
									class="filter-select"
									:disabled="bankAccountsDisabled"
									hide-details
									item-text="name"
									item-value="id"
									:items="bankAccounts"
									single-line
									v-model="billingBankAccountId"
								>
								</v-select>
							</v-flex>
						</v-layout>
						<v-layout
							v-for="billDetail in billingDetails"
							:key="billDetail.id"
							wrap mt-4
						>
							<v-flex xs12 sm3 text-xs-left pr-2>
								<label class="body-1 black--text">
									Total
								</label>
								<p class="caption ma-0 grey--text">
									Deuda
								</p>
								<v-text-field
									class="input-border-inset"
									readonly
									:value="billDetail.amount | round | currency(symbol)">
								</v-text-field>
							</v-flex>
							<v-flex xs12 sm3 text-xs-left px-2>
								<label class="body-1 black--text">
									Pagado
								</label>
								<p class="caption ma-0 grey--text">
									Monto
								</p>
								<v-text-field
									class="input-border-inset"
									readonly
									:value="billDetail.amountPayment | round | currency(symbol)">
								</v-text-field>
							</v-flex>
							<v-flex xs12 sm3 text-xs-left pl-2>
								<label class="body-1 black--text">
									A pagar
								</label>
								<p class="caption ma-0 grey--text">
									Monto
								</p>
								<v-text-field
									type="number"
									:prefix="symbol"
									class="input-border-inset"
									v-model.number="billDetail.amountToPay">
								</v-text-field>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-card-actions class="mt-3">
						<v-layout row wrap justify-center>
							<v-flex xs3 pr-1>
								<v-btn
									class="white--text darken-1"
									info
									@click.native="closeBillingDialog">
									Cerrar
								</v-btn>
							</v-flex>
							<v-flex xs3 pr-1>
								<v-btn
									class="white--text darken-1"
									success
									@click.native="payBilling">
									Pagar
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="dialogCancelBilling"
				persistent
				width="auto">
				<v-card>
					<v-card-title class="headline">
						¿Desea anular la factura {{ billingNumber }}?</v-card-title>
					<v-card-actions>
						<v-layout row wrap justify-center>
							<v-flex xs3 pr-2>
								<v-btn
									class="white--text darken-1"
									info
									@click.native="closeBillingDialog">
									Cerrar
								</v-btn>
							</v-flex>
							<v-flex xs3 pl-2>
								<v-btn
									class="white--text darken-1"
									error
									@click.native="cancelBilling">
									Anular
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog
				v-model="summaryConfirm"
				persistent
				width="auto">
				<v-card>
					<v-card-title class="headline">
						¿Desea eliminar {{ summaryName }} del resumen de cuenta?</v-card-title>
					<v-card-actions>
						<v-layout row wrap justify-center>
							<v-flex xs3 pr-2>
								<v-btn
									class="white--text darken-1"
									info
									@click.native="closeSummaryConfirm">
									Cerrar
								</v-btn>
							</v-flex>
							<v-flex xs3 pl-2>
								<v-btn
									class="white--text darken-1"
									error
									@click.native="deleteSummaryDetail">
									Eliminar
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>
		<v-layout row wrap justify-end>
			<v-flex xs2 v-if="!firstTabActive">
				<v-btn
					type="button"
					class="btn-action back btn-blue"
					@click="backToTab">
					Volver
				</v-btn>
			</v-flex>
			<v-flex xs1 v-if="firstTabActive && showCheckLoyalty">
				<v-checkbox
					label="Loyalty"
					class="input-checkbox"
					:true-value="1"
					:false-value="0"
					v-model="model.flagLoyalty"
					color="info"
					hide-details>
				</v-checkbox>
			</v-flex>
			<v-flex xs2
				v-if="firstTabActive && checkinActive">
				<v-btn
					type="button"
					class="btn-action save btn-success white--text"
					:disabled="!isToday"
					@click="saveData">
					Check in
				</v-btn>
			</v-flex>
			<v-flex xs2
				v-else>
				<v-btn
					type="button"
					class="btn-action back btn-blue"
					@click="goToSummary">
					Ver resumen de cuenta
				</v-btn>
			</v-flex>
			<v-flex xs2
				v-if="firstTabActive && !isToday">
				<v-btn
					primary
					type="button"
					class="btn-action back"
					@click="goToCalendar">
					Volver al calendario
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import modalBill from '@/clerkinn/checkin/modal-bill';
	import { email, maxLength, minLength, minValue,
		required, requiredIf } from 'vuelidate/lib/validators';
	import { differenceInDays, format, isDate, subYears,
		differenceInYears, isAfter, eachDay, addDays } from 'date-fns';
	import TableRun from 'table-run';
	import helper from '@/shared/helper';
	import mixin from '@/shared/mixins';
	import { currency, parseDate, round } from '@/shared/filters';
	import ButtonCreate from '@/components/shared/ButtonCreate';
	import ButtonField from '@/clerkinn/shared/ButtonField';

	const helperMethods = helper.methods;

	async function postPreview() {
		const dataModel = {
			codeBooking: this.bookingData.code,
			commentary: this.commentary,
			flagTaxes: this.flagTaxes,
			flagShowCustomer: this.flagShowCustomer,
			tip: this.tip,
			transactions: this.paysByTypePayment.map((pays) => {
				const newPays = {
					amount: pays.amount,
					currency: this.currencySelected,
					paymentAmount: pays.amount,
					paymentDate: format(new Date(), 'YYYY-MM-DD'),
					typePaymentId: pays.id,
				};
				return newPays;
			}),
			transactionId: this.typePaymentsSelected.map(typePay => typePay.id),
			typeDocumentCode: this.saleModel.typeDocumentCode,
			typePaymentCode: this.saleModel.typePaymentCode,
			paymentMethodCode: this.saleModel.paymentMethodCode,
			currency: this.currencySelected,
			exchangeRate: this.exchangeRate,
		};
		dataModel.details = this.newLocalProductsRows.map((local) => {
			const newLocal = { ...local };
			newLocal.detail = {
				brandId: local.brandId,
				discount: 0,
				quantity: local.quantity,
				price: local.price,
				productType: local.product.type,
				stockQuantity: local.stockQuantity,
				warProductsId: local.idDetail,
				warWarehousesId: local.warWarehousesId,
				flagIgv: local.product.flagIgv,
				flagIgvRequired: local.product.flagIgvRequired,
				igvId: local.product.igvId,
				name: local.product.name,
				code: local.product.code,
			};
			return newLocal.detail;
		});
		if (this.saleCustomerId > 0) {
			dataModel.customerId = this.saleCustomerId;
		}
		if (this.creditPayment) {
			dataModel.expirationDate = format(addDays(new Date(), this.paymentDays), 'YYYY-MM-DD');
		}
		try {
			const baseUrl = process.env.PMS_URL;
			const params = { recipe: 'phantom-pdf' };
			const codeBooking = this.bookingData.code;
			const responseType = 'blob';
			const response = await this.$http.post(`${baseUrl}/booking/${codeBooking}/report/document-previous`,
			dataModel, { params, responseType });
			const blob = helperMethods.generateBlob(response.bodyBlob);
			helperMethods.showDownloadDialog(blob, 'PREVISUALIZACIÓN DE DOCUMENTO', 'pdf', true);
		} catch (err) {
			if (err.body.message === 'CHECKIN_IS_REQUIRED') {
				this.showNotification('El CheckIn es requerido', 'error');
			} else if (err.body.message === 'CHECKIN_REQUIRED') {
				this.showNotification('El CheckIn es requerido', 'error');
			}
		}
	}

	async	function dowloadFunction() {
		const urlBase = `${process.env.PMS_URL}/report/command-preview`;
		const query = `?format=tabloid&recipe=html-with-browser-client&documentId=${this.id}`;
		const serie = `${this.sale.serie}-${this.sale.number}`;
		const response = await this.$http.post(
			`${urlBase}${query}`,
		);
		const blob = helperMethods.generateBlob(response.bodyText);
		helperMethods.showDownloadDialog(blob, serie, 'html');
	}

	function showAccommodationOption({ salDocumentsNumber }) {
		return !salDocumentsNumber;
	}

	async function saveModal(dateBill, idDetailProduct) {
		try {
			const idDetail = idDetailProduct;
			const codeProduct = this.summaryData.details[0].product.code;
			const bookingCode = this.$route.query.bookingCode;
			await this.$http.patch(`${process.env.PMS_URL}/details-booking/${idDetail}/${codeProduct}/${bookingCode}`, dateBill);
			this.closeModal();
			this.loadSummaryData();
		} catch (error) {
			if (error.status === 404) {
				if (error.data.message === 'PAYMENT_EXCEEDED_DOCUMENT') {
					this.showNotification('Ingrese de nuevo Monto Excesivo al Monto Total', 'primary');
				} if (error.data.message === 'DETAILS_NOT_FOUND') {
					this.showNotification('Detalle de Producto no encontrado', 'primary');
				}
			}
		}
	}

	function closeModal() {
		this.visibleModal = false;
		this.saveModal();
	}

	function openModal(subTotal, detail, code) {
		this.modalSubTotal = Number(subTotal);
		this.modalDetail = Number(detail);
		this.modalCode = Number(code);
		this.visibleModal = true;
	}

	function cancelModal() {
		this.visibleModal = false;
	}

	function created() {
		this.loadResources();
		this.loadCurrencies();
		this.loadExchangeRate();
		const allDays = eachDay(this.$route.query.initDate, this.$route.query.endDate);
		allDays.forEach((d) => {
			if (differenceInDays(new Date(), d) === 0) {
				this.isToday = true;
			}
		});
		if (!this.isToday) {
			this.showNotification('Esta reserva no está disponible para realizar el check in.', 'primary');
		}
		if (this.$route.query.active) {
			this.active = this.$route.query.active;
			this.loadBookingData();
		}
	}

	function actionNoteButton() {
		return this.noteId > 0 ? 'Actualizar Nota' : 'Guardar Nota';
	}

	function active(val) {
		if (val === 'tab-1' && this.$route.query.bookingCode) {
			this.loadBookingData();
		}
		if (val === 'tab-2') {
			this.loadSummaryData();
			if (Number(this.bookingData.bookingState) === 3) {
				this.showNotification('Ya se realizó el check out de esta reserva.', 'info');
			}
		}
		if (val === 'tab-3') {
			this.loadNotes();
		}
		if (val === 'tab-4') {
			this.loadBookingHistory();
		}
		if (val === 'tab-5') {
			this.loadEmails();
		}
		if (val === 'tab-6') {
			this.loadBillings();
		}
	}

	function addCustomer() {
		if (!this.saleCustomer.name
			&& !this.saleCustomer.document) {
			this.newCustomerSale.documentType = this.saleData.typeDocument;
			this.newCustomerSale.numDocument = this.saleData.numDocument;
		}
		this.salesTabs = 'tab-customer';
	}

	async function addGuest() {
		this.model.flagPerson = this.personTypeName;
		if (!this.model.flagMain) {
			this.model.codeBooking = this.bookingData.code;
			this.model.flagMain = false;
		}
		const flagUpdate = this.customerBtnText === 'Actualizar';
		const method = flagUpdate ? 'put' : 'post';
		const updateUrl = this.model.flagMain ? `customer/${this.model.id}` :
			`bookings-customer/${this.model.id}`;
		const url = flagUpdate ? updateUrl : 'bookings-customer';
		const successMessage = flagUpdate ? 'actualizado' : 'agregado';
		try {
			await this.$http[method](`${process.env.PMS_URL}/${url}`, this.model);
			this.showNotification(`El huésped ha sido ${successMessage} correctamente.`, 'success');
			this.loadBookingData();
			this.cancelAddGuest();
		} catch (err) {
			if (err.status === 405) {
				if (err.data.message === 'CUSTOMER_MAX_REGISTER') {
					this.showNotification('No se pudo agregar el huésped. La cantidad de huéspedes registrados es igual a la cantidad de huéspedes agregados en la reserva.',
						'error');
				}
				if (err.data.message === 'CHILDS_MAX_REGISTER') {
					this.showNotification('No se pudo agregar el huésped. La cantidad de niños registrados es igual a la cantidad de niños agregados en la reserva.',
						'error');
				}
			}
		}
	}

	function addGuestDisabled() {
		const childError = this.personType === 2 && this.personTypeName === 'Adulto';
		const adultError = this.personType === 1 && this.personTypeName === 'Niño(a)';
		if (childError) {
			this.showNotification('Este formulario solo acepta datos de un(a) niño(a). Para ingresar datos de un adulto cancele la operación y cambie de formulario.',
				'info');
		}
		if (adultError) {
			this.showNotification('Este formulario requiere datos de un adulto. Para ingresar datos de un niño cancele la operación y cambie de formulario.',
				'info');
		}
		return this.$v.model.$invalid || childError || adultError;
	}

	function additionalCustomersIsEmpty() {
		return this.bookingData.customerAditional.length === 0;
	}

	function addNotes() {
		this.inputNote = true;
	}

	function addPays(paymentsType) {
		this.paysByTypePayment = paymentsType.map((pay) => {
			const newAmount = this.totalLocalAmount / paymentsType.length;
			const newPay = {
				amount: newAmount.toFixed(2),
				code: pay.code,
				id: pay.id,
				name: pay.name,
			};
			return newPay;
		});
	}

	function addProductsDisabled() {
		return this.productRows.every(product => !product.isSelected);
	}

	function arrowIconBirth() {
		const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function arrowIconEnd() {
		const arrowEnd = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrowEnd;
	}

	function arrowIconProduct() {
		const arrowProduct = this.onChangeProduct ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrowProduct;
	}

	function arrowIconStart() {
		const arrowStart = this.onChangeStart ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrowStart;
	}

	function backToSales() {
		this.salesTabs = 'tab-sales';
		this.newCustomerSale = {
			address: '',
			documentType: 1,
			email: '',
			name: '',
			lastname: '',
			numDocument: '',
		};
	}

	function backToTab() {
		this.active = `tab-${this.items[(this.items.findIndex(row =>
			`tab-${row.id}` === this.active) - 1) % this.items.length].id}`;
	}

	function bankAccountsDisabled() {
		if (this.billingTypePaymentCode !== 'deposito-bancario') {
			this.billingBankAccountId = 0;
		}
		return this.billingTypePaymentCode !== 'deposito-bancario';
	}

	function billingActive() {
		return this.saleModel.typeDocumentCode === 'FAC';
	}

	function cancelAddGuest() {
		this.customerForm = false;
		this.personType = null;
		this.model = {
			address: '',
			cardVip: '',
			cityId: 0,
			civilStatus: 1,
			countryId: 0,
			dateBirth: '',
			documentType: 1,
			email: '',
			id: 0,
			gender: 1,
			lastname: '',
			name: '',
			numDocument: '',
			phone: '',
		};
	}

	async function cancelBilling() {
		const modelBillingCancel = {
			commentary: '',
			subsidiaryId: this.hotelId,
		};
		await this.$http.patch(`${process.env.PMS_URL}/point/${this.billingId}/document`,
			modelBillingCancel);
		this.showNotification('La factura ha sido anulada correctamente.', 'success');
		this.closeBillingDialog();
		this.loadBillings();
	}

	function cancelDeleteCustomer() {
		this.dialogCustomer = false;
		this.customerIdSelected = null;
		this.customerIndex = null;
	}

	function cancelDeleteNote() {
		this.noteId = 0;
		this.dialogNote = false;
	}

	function cancelUpdateChannel() {
		this.showChannelForm = false;
	}

	function cantAddGuest() {
		return !this.personType || this.customerForm;
	}

	function cantBilling() {
		return this.saleData.typeDocument !== 4 && this.saleData.typeDocument !== 2
			&& this.saleData.typeDocument !== 5;
	}

	function exchangeNumber(number, exchangeRate = 3.50) {
		return Number(number) * exchangeRate;
	}

	function crazyConvertion(cur, detailItem) {
		if (cur === 'USD') {
			return detailItem.price;
		}
		if (detailItem.product.priceSoles) {
			return detailItem.product.priceSoles;
		}
		return exchangeNumber(detailItem.price, this.exchangeRate);
	}

	function changeAmounts(currencyCode, includes) {
		if (includes) {
			this.newLocalProductsRows = this.localProductsRows.map((lpr) => {
				const newLpr = { ...lpr };
				if (lpr.product.flagIgv) {
					newLpr.price = crazyConvertion.call(this, currencyCode, lpr);
					newLpr.subTotal = currencyCode === 'USD' ? Number(lpr.subTotal) :
						Number(lpr.subTotal) * Number(this.exchangeRate);
				} else {
					newLpr.price = crazyConvertion.call(this, currencyCode, lpr);
					newLpr.subTotal = currencyCode === 'USD' ?
						Number(lpr.subTotal) + (Number(lpr.subTotal) * 0.18) :
						(Number(lpr.subTotal) + (Number(lpr.subTotal) * 0.18)) * Number(this.exchangeRate);
				}
				return newLpr;
			});
		} else {
			this.newLocalProductsRows = this.localProductsRows.map((lpr) => {
				const newLpr = { ...lpr };
				if (lpr.product.flagIgv && !lpr.product.flagIgvRequired) {
					newLpr.price = crazyConvertion.call(this, currencyCode, lpr);
					newLpr.subTotal = currencyCode === 'USD' ?
						Number(lpr.subTotal) - (Number(lpr.subTotal) * 0.18) :
						(Number(lpr.subTotal) - (Number(lpr.subTotal) * 0.18)) * Number(this.exchangeRate);
				} else {
					newLpr.price = crazyConvertion.call(this, currencyCode, lpr);
					newLpr.subTotal = currencyCode === 'USD' ? Number(lpr.subTotal) :
						Number(lpr.subTotal) * Number(this.exchangeRate);
				}
				return newLpr;
			});
		}
	}

	function changeEndIcon(result) {
		this.onChangeEnd = result;
	}

	function changeIcon(result) {
		this.onChange = result;
	}

	function changeIconProduct(result) {
		this.onChangeProduct = result;
	}

	function changeIconStart(result) {
		this.onChangeStart = result;
	}

	async function changeMainCustomer({ id }) {
		const modelMain = {
			codeBooking: this.bookingData.code,
		};
		await this.$http.put(`${process.env.PMS_URL}/bookings-customer/${id}/main`, modelMain);
		this.showNotification('Se cambió de cliente principal para la reserva.', 'success');
		this.loadBookingData();
	}

	function channelHasProperties() {
		const chanelQuestions = this.bookingData.channel.data.questions ?
		Object.keys(this.bookingData.channel.data.questions).length > 0 : false;
		return chanelQuestions;
	}

	function chargeBtnText() {
		return this.$route.query && this.$route.query.code === 'no-show' ?
			'Cobrar No-show' : 'Cobrar';
	}

	function checkinActive() {
		const state = Number(this.bookingData.bookingState);
		return state === 1 || state === 4;
	}

	async function checkout() {
		const baseUrl = `${process.env.PMS_URL}`;
		const codeBooking = this.bookingData.code;
		try {
			const { data: response } = await this.$http.put(`${baseUrl}/booking/checkout`,
				{ codeBooking });
			this.bookingData.bookingState = response.data.bookingState;
			this.showNotification('Se completó el check out de la reserva.', 'success');
			this.active = `tab-${this.items[(this.items.indexOf(row =>
				`tab-${row.id}` === this.active) + 3) % this.items.length].id}`;
		} catch (err) {
			if (err.body.message === 'CHECKIN_IS_REQUIRED') {
				this.showNotification('El CheckIn es requerido', 'error');
			}
		} finally {
			this.loadSummaryData();
		}
	}

	function checkoutDisabled() {
		return !this.summaryData.flagCheckout || Number(this.bookingData.bookingState) === 3;
	}

	function closeBillingDialog() {
		this.dialogBillingDetail = false;
		this.dialogBillingPay = false;
		this.dialogCancelBilling = false;
		this.billingDetail = {};
		this.billingDetails = [];
		this.billingId = 0;
		this.billingNumber = '';
	}

	function closeSummaryConfirm() {
		this.summaryConfirm = false;
		this.summaryId = 0;
		this.summaryName = '';
	}

	function columnSortableEvent({ id }) {
		const self = this;
		const newColumn = self.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		self.columns = self.columns.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if (columnSingle.isSortable) {
				if (columnSingle.id !== newColumn[0].id) {
					newColumnSingle.isSortable = { down: true, up: false };
				}
			}
			return newColumnSingle;
		});
		this.paramsBookingHistory.sortField = newColumn[0].code;
		this.paramsBookingHistory.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
		this.loadBookingHistory();
	}

	function confirmCancelBilling({ id, serie, number }) {
		this.billingId = id;
		this.billingNumber = `${serie}-${number}`;
		this.dialogCancelBilling = true;
	}

	function creditPayment() {
		return this.saleModel.paymentMethodCode === 'CREDITO';
	}

	function customerBtnText() {
		const customerSelected = this.bookingData.customerAditional.find(c => c.id === this.model.id);
		const idCustomer = customerSelected ? customerSelected.id : null;
		const modelId = this.model.id === this.bookingData.customer.data.id ? this.model.id : null;
		return idCustomer || modelId ? 'Actualizar' : 'Agregar';
	}

	function customerNumber() {
		return this.customerIndex + 2;
	}

	function datesDisabled(date) {
		return isAfter(new Date(), date);
	}

	async function deleteCustomer() {
		const modelDelete = {
			codeBooking: this.bookingData.code,
		};
		await this.$http.delete(`${process.env.PMS_URL}/bookings-customer/${this.customerIdSelected}`,
			{ body: modelDelete });
		this.showNotification('El cliente ha sido eliminado correctamente.', 'success');
		this.customerIndex = null;
		this.customerIdSelected = null;
		this.dialogCustomer = false;
		this.loadBookingData();
	}

	async function deleteNote() {
		await this.$http.delete(`${process.env.PMS_URL}/notes/${this.noteId}`);
		this.showNotification('La nota se eliminó correctamente.', 'success');
		this.paramsNotes.status = 1;
		this.loadNotes();
		this.noteId = 0;
		this.dialogNote = false;
	}

	async function deleteSummaryDetail() {
		const bookingCode = this.$route.query.bookingCode;
		const productCode = this.summaryProductCode;
		await this.$http.delete(
			`${process.env.PMS_URL}/details-booking/${this.summaryId}/${productCode}/${bookingCode}`,
		);
		this.showNotification('El producto del resumen de cuenta ha sido eliminado correctamente.',
			'success');
		this.closeSummaryConfirm();
		this.loadSummaryData();
	}

	function deleteSummaryDetailConfirm({ idDetail, description, product }) {
		this.summaryId = idDetail;
		this.summaryName = description || product.name;
		this.summaryProductCode = product.code;
		this.summaryConfirm = true;
	}

	function disabledSave() {
		return this.billingActive && this.cantBilling;
	}

	function disableGenerateSale() {
		return !this.creditPayment && (this.paysByTypePayment.length === 0
			|| this.paysByTypePayment.some(payByType => !payByType.amount));
	}

	function documentTypeName() {
		const docType = this.typeDocuments.find(doc => doc.id === this.saleData.typeDocument) || {};
		return docType.name;
	}

	async function downloadSale({ saleId, documentNumber }) {
		const id = saleId || this.saleId;
		const serie = documentNumber || this.documentNumber;
		const model = { code: 'pdf' };
		const responseType = 'blob';
		const params = { documentId: id };
		const response = await this.$http.post(`${process.env.PMS_URL}/report/accountStatus`,
			model, { params, responseType });
		const blob = helperMethods.generateBlob(response.data);
		helperMethods.showDownloadDialog(blob, serie, 'pdf');
	}

	async function downloadSaleTicket(documentId) {
		const urlBase = `${process.env.PMS_URL}/report/command-preview`;
		const query = `?format=tabloid&recipe=html-with-browser-client&documentId=${documentId}`;
		const serie = `COMANDA-${documentId}`;
		const response = await this.$http.post(
			`${urlBase}${query}`,
		);
		const blob = helperMethods.generateBlob(response.bodyText);
		helperMethods.showDownloadDialog(blob, serie, 'html');
	}

	async function downLoadUniqueTicket(row) {
		const { code, numReservation } = this.bookingData;
		const { id } = row;
		const name = `COMANDA-${numReservation}`;
		const baseUrl = process.env.PMS_URL;
		const query = `?format=pdf&recipe=html-with-browser-client&documentId=${id}`;
		const url = `booking/${code}/report/command-preview${query}`;
		const response = await this.$http.post(`${baseUrl}/${url}`);
		const blob = helperMethods.generateBlob(response.bodyText);
		helperMethods.showDownloadDialog(blob, name, 'html');
	}

	function earlyCheckInIsSelected() {
		return !!this.earlyCheckin;
	}

	function emailVisiblePages() {
		if (this.emailPages >= 1 && this.emailPages < 5) {
			return this.emailPages;
		}
		return 5;
	}

	function filterBookings() {
		this.paramsBookingHistory.dateInit = this.startDate;
		this.paramsBookingHistory.dateEnd = this.endDate;
		this.loadBookingHistory();
	}

	function filterProducts() {
		if (this.productCategory > 0) {
			this.paramsSummary.categories = this.productCategory;
		} else {
			delete this.paramsSummary.categories;
		}
		if (this.productWarehouse > 0) {
			this.paramsSummary.warehouses = this.productWarehouse;
		} else {
			delete this.paramsSummary.warehouses;
		}
		this.loadSummaryProducts();
	}

	function filterSummary() {
		this.paramsDocuments.dateStart = this.createdAt;
		this.paramsDocuments.dateEnd = this.createdAt;
		this.loadSummaryData();
	}

	function firstTabActive() {
		return this.active === 'tab-1';
	}

	async function generateSale() {
		const typeDocumentCode = this.saleModel.typeDocumentCode;
		const dataModel = {
			codeBooking: this.bookingData.code,
			commentary: this.commentary,
			flagTaxes: this.flagTaxes,
			flagShowCustomer: this.flagShowCustomer,
			tip: this.tip,
			transactions: this.paysByTypePayment.map((pays) => {
				const newPays = {
					amount: pays.amount,
					currency: this.currencySelected,
					paymentAmount: pays.amount,
					paymentDate: format(new Date(), 'YYYY-MM-DD'),
					typePaymentId: pays.id,
				};
				return newPays;
			}),
			transactionId: this.typePaymentsSelected.map(typePay => typePay.id),
			typeDocumentCode: this.saleModel.typeDocumentCode,
			typePaymentCode: this.saleModel.typePaymentCode,
			paymentMethodCode: this.saleModel.paymentMethodCode,
			currency: this.currencySelected,
			exchangeRate: this.exchangeRate,
		};
		dataModel.details = this.newLocalProductsRows.map((local) => {
			const newLocal = { ...local };
			newLocal.detail = {
				brandId: local.brandId,
				discount: 0,
				quantity: local.quantity,
				price: local.price,
				productType: local.product.type,
				stockQuantity: local.stockQuantity,
				warProductsId: local.idDetail,
				warWarehousesId: local.warWarehousesId,
				flagIgv: local.product.flagIgv,
				flagIgvRequired: local.product.flagIgvRequired,
				igvId: local.product.igvId,
				name: local.product.name,
				code: local.product.code,
			};
			return newLocal.detail;
		});
		if (this.saleCustomerId > 0) {
			dataModel.customerId = this.saleCustomerId;
		}
		if (this.creditPayment) {
			dataModel.expirationDate = format(addDays(new Date(), this.paymentDays), 'YYYY-MM-DD');
		}
		try {
			const dateResponse = await this.$http.post(`${process.env.PMS_URL}/booking/payments`, dataModel);
			this.showNotification('El cobro se realizó correctamente.', 'success');
			if (typeDocumentCode === 'COT') {
				const documentId = dateResponse.body.data.salePaymentId;
				this.downloadSaleTicket(documentId);
			}
			this.loadBookingData();
		} catch (err) {
			if (err.body.message === 'CHECKIN_IS_REQUIRED') {
				this.showNotification('El CheckIn es requerido', 'error');
			} else if (err.body.message === 'CHECKIN_REQUIRED') {
				this.showNotification('El CheckIn es requerido', 'error');
			}
		} finally {
			this.loadSummaryData();
			this.typePaymentsSelected = [];
			this.saleModal = false;
		}
	}

	function goToCalendar() {
		this.$router.push({ name: 'cms-calendar' });
	}

	function goToSummary() {
		this.active = `tab-${this.items[(this.items.indexOf(row =>
			`tab-${row.id}` === this.active) + 2) % this.items.length].id}`;
	}

	function isAnAdult() {
		return this.personType === 1;
	}

	function igvExonerated({ product }) {
		return product.igvId === 15;
	}

	function isNaturalPerson() {
		return this.newCustomerSale.documentType !== 4 || this.model.documentType === 5;
	}

	function isNaturalPersonModel() {
		return this.model.documentType !== 4;
	}

	function isNoShow() {
		return this.active !== 'tab-2' && this.$route.query.code
			&& this.$route.query.code === 'no-show';
	}

	function lateCheckOutIsSelected() {
		return !!this.lateCheckOut;
	}

	async function loadBankAccounts() {
		const { data: banks } = await this.$http.get(`${process.env.PMS_URL}/bank-account`);
		this.bankAccounts = banks.data;
	}

	async function loadBillingDetail(id) {
		const baseUrl = process.env.PMS_URL;
		const code = this.$route.query.bookingCode;
		const { data: billing } = await this.$http.get(`${baseUrl}/details-accounts/${code}/payments/${id}`);
		this.billingDetail = billing.data;
		this.currencySelected = billing.data.currency || billing.data.saleDocument.currency;
		if (billing.data.documentId) {
			this.billingDetails = billing.data.details.map((bill) => {
				const newBill = { ...bill };
				const toPay = bill.amount - bill.amountPayment;
				newBill.documentId = billing.data.documentId;
				newBill.amountToPay = toPay.toFixed(2);
				return newBill;
			});
		} else {
			this.billingDetails = [
				{
					amount: billing.data.amount,
					amountPayment: billing.data.amount,
					amountToPay: 0,
					documentId: billing.data.id,
					expirationDate: billing.data.createdAt,
				},
			];
		}
	}

	async function loadBillings() {
		const baseUrl = process.env.PMS_URL;
		const code = this.$route.query.bookingCode;
		const { data: billings } = await this.$http.get(`${baseUrl}/details-accounts/${code}/payments`);
		this.billingRows = billings.data.map((billing) => {
			const newBilling = { ...billing };
			newBilling.stateName = billing.flagAmountTotal ? 'Pagado' : 'Pendiente';
			newBilling.showCancel = billing.state.code !== 'ANU' && billing.typeDocument.code !== 'COT';
			newBilling.showCanceled = billing.state.code === 'ANU';
			newBilling.showPrintCot = billing.typeDocument.code === 'COT';
			return newBilling;
		});
	}

	async function loadBookingData() {
		const { data: booking } = await this.$http.get(`${process.env.PMS_URL}/bookings/${this.$route.query.bookingCode}`);
		if (!booking.data.room) {
			booking.data.room = {
				data: {
					roomTypes: {
						data: {
							codeRoomtype: '',
						},
					},
					codeRoom: '',
				},
			};
		}
		booking.data.customerAditional = booking.data.customerAditional || [];
		if (!booking.data.channel) {
			booking.data.channel = {
				data: {
					questions: {},
				},
			};
		}
		if (!booking.data.customer.data.country) {
			booking.data.customer.data.country = { data: {} };
			booking.data.customer.data.countryId = 0;
		}
		this.bookingData = booking.data;
		if (this.bookingData.summary.earlyCheckIn) {
			this.arrayEarly = this.arrayEarly.map((earlyObject) => {
				const newEarlyObject = { ...earlyObject };
				if (earlyObject.id === this.bookingData.summary.earlyCheckIn.id) {
					newEarlyObject.hour = this.bookingData.summary.earlyCheckIn ?
						this.bookingData.summary.earlyCheckIn.hour : '';
					newEarlyObject.price = this.bookingData.summary.earlyCheckIn ?
						this.bookingData.summary.earlyCheckIn.price : 0;
				}
				return newEarlyObject;
			});
			this.earlyCheckin = this.arrayEarly.find(early => early.id ===
				this.bookingData.summary.earlyCheckIn.id);
			this.earlyCheckinDisabled = true;
		}
		if (this.bookingData.summary.lateCheckOut) {
			this.arrayLate = this.arrayLate.map((lateObject) => {
				const newLateObject = { ...lateObject };
				if (lateObject.id === this.bookingData.summary.lateCheckOut.id) {
					newLateObject.hour = this.bookingData.summary.lateCheckOut ?
						this.bookingData.summary.lateCheckOut.hour : '';
					newLateObject.price = this.bookingData.summary.lateCheckOut ?
						this.bookingData.summary.lateCheckOut.price : 0;
				}
				return newLateObject;
			});
			this.lateCheckOut = this.arrayLate.find(late => late.id ===
				this.bookingData.summary.lateCheckOut.id);
			this.lateCheckOutDisabled = true;
		}
		if (this.bookingData.summary.services && this.bookingData.summary.services.length > 0) {
			const services = [...this.bookingData.summary.services];
			this.getServicesPrices(services);
		}
		const customerInfo = this.bookingData.customer ? this.bookingData.customer.data : false;
		if (customerInfo) {
			this.customerId = customerInfo.id;
			this.saleId = this.getSaleId(this.bookingData);
			this.documentNumber = this.bookingData.room ? this.bookingData.room.documentNumber
				: 0;
			if (customerInfo.flagLoyalty === 1) {
				this.showCheckLoyalty = false;
			}
		}
	}

	function getSaleId(book) {
		const dataRoom = book.room.data;
		if (dataRoom.length) {
			return dataRoom[0].saleId;
		}
		return dataRoom.saleId;
	}

	function getServicesPrices(services) {
		services.forEach((service) => {
			if (service.code === 'EXTRABEG') {
				this.bedSelected = true;
				this.aditionalBedPrice = service.price;
			}
			if (service.code === 'CRIB') {
				this.cribSelected = true;
				this.cribPrice = service.price;
			}
		});
	}

	async function loadBookingHistory(page = 1) {
		this.paramsBookingHistory.page = page;
		this.paramsBookingHistory.idCustomer = this.customerId;
		const response = await this.$http.get(`${process.env.PMS_URL}/customer/bookings`,
			{ params: this.paramsBookingHistory });
		this.totalHistoryPages = response.data.meta.pagination.total_pages;
		this.rows = response.data.data.map((row) => {
			const newRow = Object.assign({}, row);
			if (row.summary && row.summary.booking) {
				newRow.guests = row.summary.booking.adults + row.summary.booking.childrens;
			}
			return newRow;
		});
	}

	async function loadCities(id) {
		this.model.cityId = 0;
		const params = { countryId: id };
		if (id > 0) {
			const { data: cities } = await this.$http.get(`${process.env.PMS_URL}/cities`, { params });
			this.cities = cities.data;
		}
	}

	async function loadCurrencies() {
		const { data: currencies } = await this.$http.get(`${process.env.PMS_URL}/currency`);
		this.currencies = currencies.data;
		this.currencySelected = currencies.data.find(cur => cur.code === 'USD').code;
	}

	async function loadEmails(page = 1) {
		this.emailParams.page = page;
		const emailSearch = this.bookingData.customer.data.email;
		if (emailSearch) {
			const { data: emails, headers } = await this.$http.get(`${process.env.NOTIFICATIONS_URL}/notifications/${emailSearch}/email`,
				{ params: this.emailParams });
			this.emailPages = Number(headers.get('x-last-page'));
			this.emailRows = emails;
		} else {
			this.showNotification('El huésped no tiene un correo registrado.');
		}
	}

	async function loadExchangeRate() {
		const today = format(new Date(), 'YYYY-MM-DD');
		const { data: exchangeRate } = await this.$http.get(`${process.env.PMS_URL}/exchange-rates/${today}`);
		this.exchangeRate = exchangeRate.data.amount;
	}

	async function loadNotes(page = 1) {
		this.paramsNotes.page = page;
		const request = [
			this.$http.get(`${process.env.PMS_URL}/notes-list`, { params: this.paramsNotes }),
			this.$http.get(`${process.env.PMS_URL}/notes/${this.paramsNotes.bookingCode}/count`),
		];
		const [notes, count] = await Promise.all(request);
		this.notesRows = notes.data.data;
		this.totalNotesPages = notes.data.meta.pagination.total_pages;
		this.quantityNotes = count.data.data;
	}

	async function loadResources() {
		const request = [
			this.$http.get(`${process.env.PMS_URL}/roomtype/${this.hotelId}`),
			this.$http.get(`${process.env.PMS_URL}/countries`),
			this.$http.get(`${process.env.PRODUCTS_URL}/p/products/reservations`),
			this.$http.get(`${process.env.PMS_URL}/documents-type`),
		];
		const [roomsType, countries, reservationsProducts, typeDocuments] = await Promise.all(request);
		this.roomsType = roomsType.data.data;
		this.countries = countries.data.data;
		this.reservationsProducts = reservationsProducts.data;
		const roomtypeSelected = this.roomsType.find(rt => rt.id === Number(this.roomTypeId));
		this.arrayEarly = Object.assign([], roomtypeSelected.earlyCheckin);
		this.arrayLate = Object.assign([], roomtypeSelected.lateCheckout);
		this.typeDocuments = typeDocuments.data.data;
	}

	async function loadRooms(roomtypeId) {
		const response = await this.$http.get(`${process.env.PMS_URL}/roomtype/${this.hotelId}/rooms/${roomtypeId}`);
		this.rooms = response.data.data;
	}

	async function loadSaleResources() {
		const request = [
			this.$http.get(`${process.env.SALES_URL}/p/type-documents`),
			this.$http.get(`${process.env.SALES_URL}/p/type-payments`),
			this.$http.get(`${process.env.SALES_URL}/payments-methods`),
		];
		const [documents, payments, paymentMethods] = await Promise.all(request);
		const typeDocumentsModified = documents.data.map((doc) => {
			const newDoc = { ...doc };
			if (doc.documentType.code === 'COT') {
				newDoc.documentType.name = 'COMANDA';
			}
			return newDoc;
		});
		this.documentTypes[0] = typeDocumentsModified.find(tdm => tdm.documentType.code === 'BOL');
		this.documentTypes[1] = typeDocumentsModified.find(tdm => tdm.documentType.code === 'FAC');
		this.documentTypes[2] = typeDocumentsModified.find(tdm => tdm.documentType.code === 'COT');
		this.typePayments = payments.data.map((pay) => {
			const newPay = Object.assign({}, pay);
			newPay.payment = pay.paymentType;
			return newPay.payment;
		});
		this.paymentMethods = paymentMethods.data;
		this.billingTypePaymentCode = this.typePayments[0].code;
		this.saleModel.typePaymentCode = 'efectivo';
		this.saleModel.paymentMethodCode = 'CONTADO';
	}

	async function loadSummaryCategories() {
		const params = {
			permanent: 1,
		};
		const request = [
			this.$http.get(`${process.env.PRODUCTS_URL}/p/categories`),
			this.$http.get(`${process.env.PRODUCTS_URL}/p/categories`, { params }),
		];
		const [categories, categoriesPermanent] = await Promise.all(request);
		categoriesPermanent.data.forEach((categoryPermanent) => {
			const newCategory = this.categories.every(c => c.id !== categoryPermanent.id);
			if (newCategory) {
				this.categories.push(categoryPermanent);
			}
		});
		categories.data.forEach((category) => {
			const newCategory = this.categories.every(c => c.id !== category.id);
			if (newCategory) {
				this.categories.push(category);
			}
		});
		const products = this.summaryRowsData.map((row) => {
			const newRow = Object.assign({}, row);
			newRow.categoryId = row.product.categoryId;
			return newRow.categoryId;
		});
		products.forEach((p) => {
			const productCategory = this.categories.find(c => c.id === p);
			const newCategory = this.localCategories.every(lc => lc.id !== p);
			if (productCategory && newCategory) {
				this.localCategories.push(productCategory);
			}
		});
	}

	async function loadSummaryData() {
		const codeBooking = this.$route.query.bookingCode;
		const { data: summaryRows } = await this.$http.get(`${process.env.PMS_URL}/details-booking/${codeBooking}`,
			{ params: this.paramsDocuments });
		this.summaryData = summaryRows.data;
		if (summaryRows.data.id || summaryRows.data.length > 0) {
			this.documentNumber = `${summaryRows.data.serie}-${summaryRows.data.number}`;
			this.summaryRows = summaryRows.data.details.map((detail, index) => {
				const newDetail = { ...detail };
				newDetail.isSelected = false;
				newDetail.createdAt = detail.createdAt;
				newDetail.flagUse = detail.flagUse === 0 ? null : detail.flagUse;
				newDetail.flagIgv = detail.product.flagIgv;
				newDetail.flagIgvRequired = detail.product.flagIgvRequired;
				newDetail.igvId = detail.product.igvId;
				newDetail.name = detail.product.name;
				newDetail.code = detail.product.code;
				newDetail.id = detail.product.id;
				newDetail.idDetail = this.summaryData.details[index].id;
				return newDetail;
			});
		} else {
			this.documentNumber = '';
			this.summaryRows = [];
		}
		this.summaryRowsData = [...this.summaryRows];
		this.loadSummaryCategories();
	}

	async function loadSummaryProducts(page = 1) {
		this.paramsSummary.page = page;
		const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/products`, { params: this.paramsSummary });
		this.totalModalPages = Number(response.headers.get('x-last-page'));
		this.productRows = response.data.map((product) => {
			const newProduct = Object.assign({}, product);
			newProduct.quantity = 1;
			newProduct.isSelected = false;
			newProduct.discount = 0;
			return newProduct;
		});
	}

	async function loadWarehouses() {
		const params = {
			flagActive: 1,
		};
		const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/warehouses`,
			{ params });
		response.data.forEach((warehouse) => {
			this.warehouses.push(warehouse);
		});
	}

	function nameLabel() {
		return this.isNaturalPerson ? 'Nombres' : 'Razón Social';
	}

	function nameModelLabel() {
		return this.isNaturalPersonModel ? 'Nombres' : 'Razón Social';
	}

	function nameModelMessage() {
		return this.isNaturalPersonModel ? 'El nombre es requerido' :
			'La razón social es requerida';
	}

	function nameValidateMessage() {
		return this.isNaturalPerson ? 'El nombre es requerido' : 'La razón social es requerida';
	}

	function noCustomerId() {
		return this.customerId !== null && (Number(this.bookingData.bookingState) === 2
			|| Number(this.bookingData.bookingState) === 3);
	}

	function notesColumnSortableEvent({ id }) {
		const self = this;
		const newColumn = self.notesColumns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		self.notesColumns = self.notesColumns.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if (columnSingle.isSortable) {
				if (columnSingle.id !== newColumn[0].id) {
					newColumnSingle.isSortable = { down: true, up: false };
				}
			}
			return newColumnSingle;
		});
		this.notesSortField = newColumn[0].code;
		this.notesSortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	}

	function notesPagesVisible() {
		if (this.totalNotesPages >= 1 && this.totalNotesPages < 5) {
			return this.totalNotesPages;
		}
		return 5;
	}

	function numberNights() {
		return differenceInDays(this.$route.query.endDate, this.$route.query.initDate);
	}

	function numDocumentLength() {
		if (this.model.documentType === 1) {
			return 8;
		} else if (this.model.documentType === 4) {
			return 11;
		}
		return 0;
	}

	function openBillingDetail({ id }) {
		this.loadBillingDetail(id);
		this.dialogBillingDetail = true;
	}

	function openBillingPay({ id }) {
		this.loadSaleResources();
		this.loadBankAccounts();
		this.loadBillingDetail(id);
		this.dialogBillingPay = true;
	}

	function openDeleteConfirm(id) {
		this.noteId = id;
		this.dialogNote = true;
	}

	function openDeleteCustomer(index, { id }) {
		this.customerIndex = index;
		this.customerIdSelected = id;
		this.dialogCustomer = true;
	}

	function openProductsModal() {
		this.loadWarehouses();
		this.loadSummaryProducts();
		this.dialog = true;
	}

	function openSaleModal() {
		this.loadSaleResources();
		this.localProductsRows = this.summaryRowsData.filter(srd => srd.isSelected);
		this.newLocalProductsRows = [...this.localProductsRows];
		this.saleData.numDocument = this.bookingData.customer.data.numDocument;
		this.saleData.typeDocument = this.bookingData.customer.data.documentType;
		this.saleCustomer.name = `${this.bookingData.customer.data.name} ${this.bookingData.customer.data.lastname}`;
		this.saleCustomer.document = this.bookingData.customer.data.numDocument;
		this.saleCustomer.paymentMethod = this.saleModel.paymentMethodCode;
		this.saleModal = true;
		this.validateExoneration(this.flagTaxes);
	}

	function pagesVisible() {
		if (this.totalModalPages >= 1 && this.totalModalPages < 5) {
			return this.totalModalPages;
		}
		return 5;
	}

	async function payBilling() {
		const billingModel = {
			bankAccountId: this.billingBankAccountId > 0 ? this.billingBankAccountId : null,
			typePaymentCode: this.billingTypePaymentCode,
			currency: this.currencySelected,
			amount: this.billingDetails[0].amountToPay,
			codeBooking: this.$route.query.bookingCode,
			idDocument: this.billingDetail.documentId,
		};
		await this.$http.post(`${process.env.PMS_URL}/amortizations`, billingModel);
		this.showNotification('El pago se realizó correctamente.', 'success');
		this.closeBillingDialog();
		this.loadBillings();
	}

	function pagesVisibleHistory() {
		if (this.totalHistoryPages >= 1 && this.totalHistoryPages < 5) {
			return this.totalHistoryPages;
		}
		return 5;
	}

	function personTypeName() {
		const namePerson = differenceInYears(new Date(), this.model.dateBirth) >= 18 ?
			'Adulto' : 'Niño(a)';
		return this.model.dateBirth ? namePerson : '';
	}

	function positiveValue(product, prop) {
		const productIndex = this.productRows.findIndex(pro => pro.id === product.id);
		if (productIndex > -1) {
			this.productRows[productIndex].isSelected = product[prop] && product[prop] > 0;
		}
	}

	function previewEmail({ id }) {
		window.open(`${process.env.NOTIFICATIONS_URL}/notifications/${id}/view`);
	}

	function printDisabled() {
		return this.summaryRows.filter(sr => sr.isSelected).length === 0;
	}

	function saleDisabled() {
		return this.summaryRows.every(r => !r.isSelected);
	}

	function saleNumDocumentLength() {
		if (this.newCustomerSale.documentType === 1) {
			return 8;
		} else if (this.newCustomerSale.documentType === 4) {
			return 11;
		}
		return 0;
	}

	async function saveCustomer() {
		const { data: customer } = await this.$http.post(`${process.env.PMS_URL}/customers`,
			this.newCustomerSale);
		this.showNotification('El cliente ha sido registrado correctamente.', 'success');
		this.saleCustomer.name = `${this.newCustomerSale.name} ${this.newCustomerSale.lastname}`;
		this.saleCustomer.document = this.newCustomerSale.numDocument;
		this.saleData.typeDocument = this.newCustomerSale.documentType;
		this.saleData.numDocument = this.newCustomerSale.numDocument;
		this.saleCustomerId = customer.data.id;
		this.backToSales();
	}

	async function saveData() {
		if (!this.bookingData.customer.data.flagGeneric) {
			const modelData = {
				codeBooking: this.bookingData.code,
				idSubsidiary: this.hotelId,
				specialRequest: this.bookingData.summary.personalInformation.specialRequest,
				extraBed: this.bedSelected ? this.getExtraBed(this.aditionalBedPrice) : null,
				addCrib: this.cribSelected ? this.getCrib(this.cribPrice) : null,
			};
			if (this.earlyCheckin) {
				modelData.earlyCheckin = this.earlyCheckin;
			}
			if (this.lateCheckOut) {
				modelData.lateCheckout = this.lateCheckOut;
			}
			try {
				const { data: checkin } = await this.$http.put(`${process.env.PMS_URL}/booking/checkin`, modelData);
				this.customerId = checkin.data.id;
				if (!this.saleId || this.saleId === 0) {
					this.saleId = checkin.data.room.data.saleId;
				}
				if (!this.bookingData.bookingState) {
					this.bookingData.bookingState = checkin.data.bookingState;
				}
				this.showNotification('La información se guardó correctamente.', 'success');
				this.active = `tab-${this.items[(this.items.indexOf(row =>
				`tab-${row.id}` === this.active) + 2) % this.items.length].id}`;
			} catch (err) {
				if (err.status === 405) {
					this.showNotification('Esta habitación no cuenta con disponibilidad para las fechas seleccionadas.', 'error');
				} else if (err.status === 400) {
					if (err.data.cellPhone) {
						this.showNotification('El teléfono celular debe tener entre 9 y 11 dígitos.', 'error');
					}
				}
			}
		} else {
			this.showNotification(
				'Este usuario es Genérico, no es posible hacer CheckIn',
				'warning',
			);
		}
	}

	async function saveNote({ note, id, status }) {
		const update = id || this.noteId > 0;
		const updateId = id || this.noteId;
		const method = update ? 'put' : 'post';
		const url = update ? `notes/${updateId}` : 'notes';
		const archiveMessage = status > 0 ? 'archivó' : 'activó';
		const filter = status && (status > 1) ? 1 : 2;
		const filterVal = id ? filter : 1;
		const saveMessage = this.noteId > 0 ? 'actualizó' : 'creó';
		const archiveModel = {
			note,
			status: status > 1 ? 1 : 2,
		};
		const updateModel = {
			note: this.note,
			status: this.noteStatus,
		};
		const createModel = {
			note: this.note,
			bookingCode: this.$route.query.bookingCode,
			status: 1,
			flagActive: 1,
		};
		const putModel = id ? archiveModel : updateModel;
		const model = update ? putModel : createModel;
		const message = id ? archiveMessage : saveMessage;
		await this.$http[method](`${process.env.PMS_URL}/${url}`, model);
		this.showNotification(`La nota se ${message} correctamente.`, 'success');
		this.filterValue = filterVal;
		this.paramsNotes.status = model.status;
		this.loadNotes();
		this.note = '';
		this.noteId = 0;
		this.noteStatus = null;
		this.inputNote = false;
	}

	function searchByColumn(search) {
		this.paramsBookingHistory.search = search;
		this.loadBookingHistory();
	}

	async function searchCustomer() {
		const params = {
			documentType: this.model.documentType,
			numDocument: this.model.numDocument,
		};
		if (this.model.numDocument !== '') {
			try {
				const { data: customer } = await this.$http.get(`${process.env.PMS_URL}/customer-search`,
					{ params });
				if (customer.data) {
					this.model = customer.data;
					this.model.countryId = `${process.env.DEFAULT_COUNTRY_ID}`;
					this.model.dateBirth = customer.data.dateBirth &&
						isDate(new Date(customer.data.dateBirth)) ?
						customer.data.dateBirth : format(subYears(new Date(), 18), 'YYYY-MM-DD');
					if (this.model.flagLoyalty === 1) {
						this.showCheckLoyalty = false;
					}
				}
			} catch (err) {
				if (err.status === 405) {
					if (err.data.message === 'CUSTOMER_NOT_FOUND') {
						if (Number(this.model.documentType) === 4) {
							this.searchCustomerByMixin();
						} else {
							this.showNotification('El cliente no se encuentra registrado',
								'error');
						}
					}
				} else if (err.status === 404) {
					if (err.data.message === 'CUSTOMER_NOT_FOUND') {
						if (Number(this.model.documentType) === 4) {
							this.searchCustomerByMixin();
						} else {
							this.showNotification('El cliente no se encuentra registrado',
								'error');
						}
					}
				}
			}
		}
	}

	async function searchCustomerByMixin() {
		try {
			const { data: customer } = await this.mixinSearchCustomer(this.model.documentType,
				this.model.numDocument);
			const newCustomer = {
				address: customer.data.domicilio,
				cardVip: '',
				cityId: 0,
				civilStatus: 0,
				countryId: process.env.DEFAULT_COUNTRY_ID,
				dateBirth: customer.data.fecha_inscripcion
					&& customer.data.fecha_inscripcion !== '0000-00-00'
					&& isDate(new Date(customer.data.fecha_inscripcion)) ?
					customer.data.fecha_inscripcion :
					format(subYears(new Date(), 18), 'YYYY-MM-DD'),
				documentType: 4,
				email: '',
				flagLoyalty: false,
				flagTaxes: false,
				gender: 0,
				lastname: '',
				name: customer.data.nombre,
				numDocument: customer.data.ruc,
				phone: customer.data.telefono,
			};
			this.model = { ...newCustomer };
		} catch (err) {
			if (err.status === 405) {
				if (err.data.message === 'No se ha encontrado resultados.') {
					this.showNotification('No se encontraron resultados.', 'error');
				}
			}
		}
	}

	async function searchCustomerSale() {
		const params = {
			documentType: this.saleData.typeDocument,
			numDocument: this.saleData.numDocument,
		};
		if (this.saleData.numDocument !== '') {
			try {
				const { data: customer } = await this.$http.get(`${process.env.PMS_URL}/customer-search`,
					{ params });
				if (customer.data) {
					const saleCustomer = customer.data;
					this.saleCustomer.name = `${saleCustomer.name} ${saleCustomer.lastname}`;
					this.saleCustomer.document = saleCustomer.numDocument;
					this.saleCustomerId = customer.data.id;
				}
			} catch (err) {
				if (err.status === 405) {
					if (err.data.message === 'CUSTOMER_NOT_FOUND') {
						this.saleData.typeDocument = this.bookingData.customer.data.documentType;
						this.saleData.numDocument = this.bookingData.customer.data.numDocument;
						this.alertMessage = 'El cliente buscado no se encuentra registrado. Puede continuar el proceso con el cliente registrado en la reserva o agregar el cliente en el tab "Nuevo Cliente".';
						this.alertWarning = false;
						this.alertInfo = true;
						this.alert = true;
					}
				} else if (err.status === 404) {
					if (err.data.message === 'CUSTOMER_NOT_FOUND') {
						this.saleData.typeDocument = this.bookingData.customer.data.documentType;
						this.saleData.numDocument = this.bookingData.customer.data.numDocument;
						this.alertMessage = 'El cliente buscado no se encuentra registrado. Puede continuar el proceso con el cliente registrado en la reserva o agregar el cliente en el tab "Nuevo Cliente".';
						this.alertWarning = false;
						this.alertInfo = true;
						this.alert = true;
					}
				}
			}
		}
	}

	async function searchCustomerNew() {
		if (Number(this.newCustomerSale.documentType) === 4) {
			const { data: customer } = await this.$http.get(
				`${process.env.PERU_DATOS_URL}/ruc/${this.newCustomerSale.numDocument}`,
			);
			this.newCustomerSale.name = customer.data.nombre;
			this.newCustomerSale.document = customer.data.ruc;
		}
	}

	function searchProductsByColumn(search) {
		this.paramsSummary.code = search;
		this.loadSummaryProducts();
	}

	function selectCategory(id) {
		this.categoryValue = id;
		const products = [];
		if (id > 0) {
			this.categories.forEach((category) => {
				if (category.id === id) {
					const newProduct = this.summaryRowsData.find((row) => {
						if (row.product) {
							return id === row.product.categoryId;
						}
						return false;
					});
					if (newProduct) {
						products.push(newProduct);
					}
				}
			});
			if (products.length > 0) {
				this.summaryRows = products;
			} else {
				this.summaryRows = [];
			}
		} else {
			this.summaryRows = this.summaryRowsData;
		}
	}

	function selectFilter(id) {
		this.filterValue = id;
		this.paramsNotes.status = id;
		this.loadNotes();
	}

	function setPaymentMethod(value) {
		this.saleCustomer.paymentMethod = this.paymentMethods.find(pm => pm.code
			=== value).name;
		if (value === 'CREDITO') {
			this.paysByTypePayment = [];
			this.typePaymentsSelected = [];
		}
	}

	function setTypeDocument(value) {
		this.saleCustomer.typeDocument = this.documentTypes.find(dt => dt.documentType.code
			=== value).documentType.name;
		if (value !== 'FAC') {
			this.validateExoneration();
			this.showError();
		} else {
			this.showError();
		}
	}

	function setTypePayment(value) {
		this.saleCustomer.typePayment = this.typePayments.find(tp => tp.code
			=== value).name;
	}

	function showChannelData() {
		this.bookingData.channel.data.inputInformations =
			this.bookingData.channel.data.inputInformations.map((field) => {
				const newField = { ...field };
				newField[field.value] = this.bookingData.channel.data.questions[field.value];
				if (!field.items) {
					newField.items = {
						itemText: '',
						itemValue: '',
						name: [],
					};
				} else {
					newField.items.name = Object.assign([], this[field.items.name]);
				}
				return newField;
			});
		this.showChannelForm = true;
	}

	function showCustomerData(info, type) {
		const newInfo = { ...info };
		if (type) {
			newInfo.flagPerson = 'Adulto';
			newInfo.countryId = this.bookingData.customer.data.country.data.id;
		}
		this.personType = newInfo.flagPerson === 'Adulto' ? 1 : 2;
		this.model = newInfo;
		this.customerForm = true;
	}

	function showError() {
		if (this.cantBilling) {
			this.showNotification('Para generar una factura es necesario tener el RUC o pasaporte del cliente.',
				'primary');
		} else {
			this.flagTaxes = true;
			this.validateExoneration(this.flagTaxes);
		}
	}

	function showGuestForm() {
		if (!this.model.dateBirth) {
			this.model.dateBirth = this.personType === 1 ?
				format(subYears(new Date(), 18), 'YYYY-MM-DD') : format(new Date(), 'YYYY-MM-DD');
		}
		this.customerForm = true;
	}

	function deletePeque({ product }) {
		return product.name !== 'Alojamiento';
	}

	function showSummaryOption({ salDocumentsNumber, product }) {
		return product.code !== 'RESERVA' && !salDocumentsNumber;
	}

	function showTypeBooking() {
		return (!this.saleId && (!this.bookingData.bookingState
			|| Number(this.bookingData.bookingState) === 1));
	}

	function symbol() {
		const curSelected = this.currencies.find(cur => cur.code === this.currencySelected) ||
			{ saleDocument: {} };
		return curSelected.symbol || curSelected.saleDocument.symbol;
	}

	function toggleIconBirthDate() {
		this.onChange = !this.modal.dateBirth;
	}

	function toggleIconEndDate() {
		this.onChangeEnd = !this.endDate;
	}

	function toggleIconProductDate() {
		this.onChangeProduct = !this.createdAt;
	}

	function toggleIconStartDate() {
		this.onChangeStart = !this.startDate;
	}

	function totalAmount() {
		const total = this.summaryRows.reduce((acum, row) => acum + row.subTotal, 0);
		return total;
	}

	function totalLocalAmount() {
		const totalLocal = this.newLocalProductsRows.reduce((acum, row) =>
			acum + (row.price * row.quantity), 0);
		return Number(totalLocal).toFixed(2);
	}

	function totalNotes() {
		return this.bookingData.countNotes || this.quantityNotes.countNotes;
	}

	async function updateChannel() {
		const modelUpdate = {
			codeBooking: this.bookingData.code,
			channelInformation: this.bookingData.channel.data.questions,
		};
		await this.$http.put(`${process.env.PMS_URL}/booking/channel`, modelUpdate);
		this.showNotification('La información del canal se actualizó correctamente.', 'success');
		this.showChannelForm = false;
		this.loadBookingData();
	}

	function updateNote(row, status) {
		this.note = row.note;
		this.noteId = row.id;
		this.noteStatus = status;
		this.inputNote = true;
	}

	async function updateProducts() {
		const code = this.$route.query.bookingCode;
		const details = this.productRows.map((product) => {
			const newProduct = Object.assign({}, product);
			if (product.isSelected) {
				newProduct.detail = {
					brandId: product.brandId,
					discount: product.discount,
					quantity: Number(product.quantity),
					price: product.price,
					productType: product.type,
					stockQuantity: product.stock,
					warProductsId: product.id,
					warWarehousesId: product.warehouseId,
				};
			}
			return newProduct.detail;
		});
		const model = details.filter(detail => detail);
		const productWithOutWarehouse = this.productRows.find(p => p.isSelected && !p.warehouseId);
		if (!productWithOutWarehouse) {
			await this.$http.patch(
				`${process.env.PMS_URL}/sale/details/${code}`, model);
			this.showNotification('Se agregaron nuevos productos.', 'success');
			this.dialog = false;
			this.loadSummaryData();
		} else if (productWithOutWarehouse) {
			this.showNotification('Uno o más productos seleccionados ya han sido agregados y no cuentan con un almacén asignado.', 'error');
		} else {
			this.showNotification('Uno o más productos seleccionados no cuentan con un almacén asignado.', 'error');
		}
	}

	function validateAmount() {
		const paysAmount = this.paysByTypePayment.reduce((acum, currentPay) =>
			acum + Number(currentPay.amount), 0);
		return !this.creditPayment && (Number(paysAmount) !== Number(this.totalLocalAmount));
	}

	function validateExoneration(flag) {
		this.invalid = flag && this.newLocalProductsRows.some(lsr => lsr.product.igvId === 13 &&
			lsr.product.flagIgvRequired) && this.saleModel.typeDocumentCode === 'FAC';
		this.invalidBol = this.newLocalProductsRows.some(lsr => lsr.product.igvId === 15) &&
			(this.saleModel.typeDocumentCode === 'BOL' || (!flag &&
			this.saleModel.typeDocumentCode === 'FAC'));
		if (flag && this.saleModel.typeDocumentCode === 'FAC') {
			this.changeAmounts(this.currencySelected);
			this.addPays(this.paysByTypePayment);
		} else {
			this.changeAmounts(this.currencySelected, true);
			this.addPays(this.paysByTypePayment);
		}
		if (this.invalid) {
			this.alertMessage = 'No se puede exonerar de impuestos esta venta porque uno o más productos han sido configurados con impuesto obligatorio.';
			this.alertInfo = false;
			this.alertWarning = true;
			this.alert = true;
		} else if (this.invalidBol) {
			this.alertMessage = 'No se puede generar la venta con boleta porque uno o más productos agregados han sido configurados con impuesto exonerado. Puede continuar con el proceso si genera una factura exonerando impuestos.';
			this.alertInfo = false;
			this.alertWarning = true;
			this.alert = true;
		} else {
			this.alert = false;
		}
	}

	async function updateCheckOut() {
		this.disabledUpdateCheckOut = true;
		const codeBooking = this.bookingData.code;
		const bodyUpdate = {
			idSubsidiary: this.hotelId,
			lateCheckout: Object.assign({}, this.lateCheckOut),
		};
		try {
			await this.$http.put(`${process.env.PMS_URL}/booking-checkout/${codeBooking}`, bodyUpdate);
		} catch (err) {
			this.showNotification('No se realizo el check out', 'success');
			this.disabledUpdateCheckOut = false;
		} finally {
			this.showNotification('Se realizo el check out', 'error');
			this.disabledUpdateCheckOut = true;
		}
	}

	function goToBill(id) {
		const routeGoToSales = this.$router.resolve({ path: `/sales/${id}/detail` });
		window.open(routeGoToSales.href, '_blank');
	}

	function validations() {
		const model = {
			countryId: {
				minValue: minValue(1),
				required,
			},
			documentType: {
				required,
			},
			email: {
				email,
			},
			lastname: {
				required: requiredIf(() => this.isNaturalPersonModel),
			},
			name: {
				required,
			},
			numDocument: {
				required,
			},
		};
		const newCustomerSale = {
			address: {
				required,
			},
			documentType: {
				required,
			},
			email: {
				email,
			},
			lastname: {
				required: requiredIf(() => this.isNaturalPerson),
			},
			name: {
				required,
			},
			numDocument: {
				required,
			},
		};
		if (this.numDocumentLength > 0) {
			model.numDocument.maxLength = maxLength(this.numDocumentLength);
			model.numDocument.minLength = minLength(this.numDocumentLength);
		}
		if (this.saleNumDocumentLength > 0) {
			newCustomerSale.numDocument.maxLength = maxLength(this.saleNumDocumentLength);
			newCustomerSale.numDocument.minLength = minLength(this.saleNumDocumentLength);
		}
		return {
			model,
			newCustomerSale,
			saleCustomer: {
				name: {
					required,
				},
				document: {
					required,
				},
				paymentMethod: {
					required,
				},
				typeDocument: {
					required,
				},
			},
			paymentDays: {
				required: requiredIf(() => this.creditPayment),
				minValue: minValue(this.creditPayment ? 15 : 0),
			},
		};
	}

	function getExtraBed(price) {
		return {
			id: 1,
			quantity: 1,
			flag: 1,
			price,
		};
	}

	function getCrib(price) {
		return {
			id: 2,
			quantity: 1,
			flag: 1,
			price,
		};
	}

	function selectBed(value) {
		this.bedSelected = value;
	}

	function selectCrib(value) {
		this.cribSelected = value;
	}

	function getTypeAndCodeRoom(book) {
		const bookData = book.room.data;
		if (bookData.length) {
			const rooms = bookData.map((r) => {
				const { codeRoom } = r;
				const { codeRoomtype } = r.roomTypes.data;
				return `${codeRoomtype}-${codeRoom}`;
			});
			return rooms.join(', ');
		}
		return `${bookData.roomTypes.data.codeRoomtype} - ${bookData.codeRoom}`;
	}

	function getTypeDocumentName(row) {
		let name = row.typeDocument.name;
		if (name === 'COTIZACION') {
			name = 'COMANDA';
		}
		return name;
	}

	function data() {
		return {
			tip: '',
			modalDetail: '',
			modalCode: '',
			modalSubTotal: '',
			modalAccommodation: [
				{
					id: 1,
					price: 0,
				},
				{
					id: 2,
					prince: 1,
				},
			],
			visibleModal: false,
			active: null,
			aditionalBedPrice: '20.00',
			alert: false,
			alertMessage: '',
			arrayEarly: [
				{ id: 1, flag: 1, price: '', hour: '' },
				{ id: 2, flag: 1, price: '', hour: '' },
				{ id: 3, flag: 1, price: '', hour: '' },
			],
			arrayLate: [
				{ id: 1, flag: 1, price: '', hour: '' },
				{ id: 2, flag: 1, price: '', hour: '' },
				{ id: 3, flag: 1, price: '', hour: '' },
			],
			bankAccounts: [],
			bed: [1],
			bedSelected: false,
			billingColumns: [
				{ id: 1, name: 'Nº Doc' },
				{ id: 2, name: 'Tipo de Documento' },
				{ id: 3, name: 'Fecha' },
				{ id: 4, name: 'Estado' },
				{ id: 5, name: 'Acciones' },
			],
			billingDetail: {},
			billingDetailsColumns: [
				{ id: 1, name: 'Nº Doc' },
				{ id: 2, name: 'Fecha' },
				{ id: 3, name: 'Total' },
				{ id: 4, name: 'Pagado' },
				{ id: 5, name: 'A pagar' },
			],
			billingDetails: [],
			billingId: 0,
			billingNumber: '',
			billingRows: [],
			billingBankAccountId: 0,
			billingTypePaymentCode: '',
			bookingData: {
				channel: {
					data: {
						inputInformations: [{ items: {} }],
						questions: {},
					},
				},
				customerAditional: [],
				customer: {
					data: {
						country: {
							data: {},
						},
					},
				},
				room: {
					data: {
						roomTypes: {
							data: {},
						},
					},
				},
				summary: {
					booking: {},
					personalInformation: {},
					earlyCheckIn: {},
					lateCheckOut: {},
				},
			},
			bookingTotal: 0,
			categories: [
				{ id: 0, name: 'Todas' },
			],
			categoryValue: 0,
			channelModel: {},
			cities: [],
			civilStatus: [
				{ id: 1, name: 'Soltero(a)' },
				{ id: 2, name: 'Casado(a)' },
				{ id: 3, name: 'Viudo(a)' },
				{ id: 4, name: 'Divorciado(a)' },
			],
			columns: [
				{ id: 1, name: '#', code: 'number' },
				{ id: 2, name: 'Habitación', code: 'room' },
				{ id: 3, name: 'Huésped', code: 'customer' },
				{ id: 4, name: 'Llegada/Salida', code: 'ranges' },
				{ id: 5, name: 'Huéspedes', code: 'guests' },
				{ id: 6, name: 'Noches', code: 'nights' },
				{ id: 7, name: 'Total', code: 'total' },
				{ id: 8, name: 'Descargar' },
			],
			commentary: '',
			countries: [],
			createdAt: null,
			cribPrice: '20.00',
			cribSelected: false,
			currencies: [],
			currencySelected: '',
			customerForm: false,
			customerId: null,
			customerIdSelected: null,
			customerIndex: null,
			dialog: false,
			dialogBillingDetail: false,
			dialogBillingPay: false,
			dialogCancelBilling: false,
			dialogCustomer: false,
			dialogNote: false,
			documentNumber: '',
			documentTypes: [],
			earlyCheckin: null,
			earlyCheckinDisabled: false,
			emailColumns: [
				{ id: 1, name: 'Fecha' },
				{ id: 2, name: 'Remitente' },
				{ id: 3, name: 'Destinatario' },
				{ id: 4, name: 'Asunto' },
				{ id: 5, name: 'Ver email' },
			],
			emailPages: 5,
			emailParams: {
				page: 1,
				limit: 10,
			},
			emailRows: [],
			endDate: null,
			exchangeRate: '',
			flagTaxes: false,
			flagShowCustomer: true,
			filters: [
				{ id: 1, label: 'Notas activas' },
				{ id: 2, label: 'Notas archivadas' },
			],
			filterValue: 1,
			genders: [
				{ id: 1, name: 'Hombre' },
				{ id: 2, name: 'Mujer' },
			],
			inputNote: false,
			invalid: false,
			invalidBol: false,
			isToday: false,
			items: [
				{ id: 1, title: 'Detalle de Huésped' },
				{ id: 2, title: 'Resumen de cuenta' },
				{ id: 3, title: 'Notas' },
				{ id: 4, title: 'Historial de reservas' },
				{ id: 5, title: 'Email enviados' },
				{ id: 6, title: 'Facturas' },
			],
			lateCheckOut: null,
			lateCheckOutDisabled: false,
			loading: false,
			localCategories: [
				{ id: 0, name: 'Todas' },
			],
			localProductsColumns: [
				{ id: 1, name: 'Fecha' },
				{ id: 2, name: 'Cod. Producto' },
				{ id: 3, name: 'Categoría' },
				{ id: 4, name: 'Nombre Producto' },
				{ id: 5, name: 'Cant.' },
				{ id: 6, name: 'Precio Producto' },
				{ id: 7, name: 'Descuento %' },
			],
			localProductsRows: [],
			menu: false,
			menuBirthDate: false,
			menuEnd: false,
			menuProduct: false,
			model: {
				address: '',
				cardVip: '',
				cityId: 0,
				civilStatus: 1,
				countryId: 0,
				dateBirth: '',
				documentType: 1,
				email: '',
				gender: 1,
				lastname: '',
				name: '',
				numDocument: '',
				phone: '',
			},
			newCustomerSale: {
				address: '',
				documentType: 1,
				email: '',
				lastname: '',
				name: '',
				numDocument: '',
			},
			newLocalProductsRows: [],
			note: '',
			noteStatus: null,
			noteId: 0,
			notesColumns: [
				{ id: 1, name: 'Nota', code: 'note', isSortable: { down: true, up: false } },
				{ id: 2, name: '', code: 'action' },
			],
			notesRows: [],
			numberDays: [15, 30, 60, 90],
			onChange: false,
			onChangeProduct: false,
			onChangeEnd: false,
			onChangeStart: false,
			params: {
				room: null,
			},
			paramsBookingHistory: {
				page: 1,
				perPage: 10,
				idCustomer: null,
			},
			paramsDocuments: {},
			paramsNotes: {
				bookingCode: this.$route.query.bookingCode,
				status: 1,
				page: 1,
				perPage: 10,
			},
			paramsSummary: {
				page: 1,
				limit: 10,
				withTransfer: 1,
			},
			paymentDays: 0,
			paymentMethods: [],
			paysByTypePayment: [],
			personType: null,
			productCategory: 0,
			productColumns: [
				{ id: 1, name: 'Cod. Prod.', code: 'code' },
				{ id: 2, name: 'Almacén', code: 'warehouse' },
				{ id: 3, name: 'Categoría', code: 'category' },
				{ id: 4, name: 'Nombre Prod.', code: 'name' },
				{ id: 5, name: 'Stock', code: 'stock' },
				{ id: 6, name: 'Cant.', code: 'quantity' },
				{ id: 7, name: 'Precio', code: 'price' },
				{ id: 8, name: 'Descuento %', code: 'discount' },
			],
			productRows: [],
			productSearch: '',
			productWarehouse: 0,
			quantityNotes: {
				filedNotes: 0,
				activeNotes: 0,
				countNotes: 0,
			},
			reservationsProducts: [],
			rooms: [],
			roomsType: [],
			rows: [],
			saleCustomer: {
				name: '',
				document: '',
				paymentMethod: '',
				typeDocument: 'BOLETA',
				typePayment: '',
			},
			saleCustomerId: 0,
			saleData: {
				numDocument: '',
				typeDocument: 1,
			},
			saleId: 0,
			saleModal: false,
			saleModel: {
				paymentMethodCode: '',
				typeDocumentCode: 'BOL',
				typePaymentCode: '',
			},
			saleNumDocument: '',
			salesTabs: null,
			search: '',
			servicesBedCode: 'EXTRABEG',
			servicesCribCode: 'CRIB',
			showChannelForm: false,
			showCheckLoyalty: false,
			sortField: null,
			sortDirection: null,
			specialRequirement: '',
			startDate: null,
			createdHour: null,
			summaryColumns: [
				{ id: 0, name: 'Fecha', code: 'createdAt' },
				{ id: 1, name: 'Hora', code: 'createdHour' },
				{ id: 2, name: 'Cod. Producto', code: 'code' },
				{ id: 3, name: 'Cant.', code: 'quantity' },
				{ id: 4, name: 'Nombre Producto', code: 'name' },
				{ id: 5, name: 'Precio Producto', code: 'price' },
				{ id: 6, name: 'Nº Factura', code: 'billingNumber' },
				{ id: 7, name: '' },
			],
			summaryConfirm: false,
			summaryData: {},
			summaryId: 0,
			summaryName: '',
			summaryProductCode: '',
			summaryRows: [],
			summaryRowsData: null,
			totalHistoryPages: 5,
			totalModalPages: 5,
			totalNotesPages: 5,
			typeBooking: 0,
			typeCard: 1,
			typeCards: [{ id: 1, name: 'VIP' }],
			typeDocuments: [
				{ id: 1, name: 'DNI' },
				{ id: 2, name: 'Pasaporte' },
				{ id: 3, name: 'C. Extranjería' },
				{ id: 4, name: 'RUC' },
			],
			typePayments: [],
			typePaymentsSelected: [],
			warehouses: [
				{ id: 0, name: 'Todos' },
			],
			disabledUpdateCheckOut: false,
		};
	}

	export default {
		name: 'checkin-form-tabs',
		components: {
			modalBill,
			ButtonCreate,
			ButtonField,
			TableRun,
		},
		computed: {
			actionNoteButton,
			addGuestDisabled,
			additionalCustomersIsEmpty,
			addProductsDisabled,
			arrowIconBirth,
			arrowIconEnd,
			arrowIconProduct,
			arrowIconStart,
			bankAccountsDisabled,
			billingActive,
			cantAddGuest,
			cantBilling,
			channelHasProperties,
			chargeBtnText,
			checkinActive,
			checkoutDisabled,
			creditPayment,
			customerBtnText,
			customerNumber,
			disabledSave,
			disableGenerateSale,
			documentTypeName,
			earlyCheckInIsSelected,
			emailVisiblePages,
			firstTabActive,
			isAnAdult,
			isNaturalPerson,
			isNaturalPersonModel,
			isNoShow,
			lateCheckOutIsSelected,
			nameLabel,
			nameModelLabel,
			nameModelMessage,
			nameValidateMessage,
			noCustomerId,
			notesPagesVisible,
			numberNights,
			numDocumentLength,
			saleNumDocumentLength,
			showTypeBooking,
			pagesVisible,
			pagesVisibleHistory,
			personTypeName,
			printDisabled,
			saleDisabled,
			symbol,
			totalAmount,
			totalLocalAmount,
			totalNotes,
			validateAmount,
		},
		created,
		data,
		filters: {
			currency,
			parseDate,
			round,
		},
		methods: {
			postPreview,
			dowloadFunction,
			showAccommodationOption,
			saveModal,
			cancelModal,
			openModal,
			closeModal,
			deletePeque,
			addCustomer,
			addGuest,
			addNotes,
			addPays,
			backToSales,
			backToTab,
			cancelAddGuest,
			cancelBilling,
			cancelDeleteCustomer,
			cancelDeleteNote,
			cancelUpdateChannel,
			changeAmounts,
			changeEndIcon,
			changeIcon,
			changeIconProduct,
			changeIconStart,
			changeMainCustomer,
			checkout,
			closeBillingDialog,
			closeSummaryConfirm,
			columnSortableEvent,
			confirmCancelBilling,
			datesDisabled,
			deleteCustomer,
			deleteNote,
			deleteSummaryDetail,
			deleteSummaryDetailConfirm,
			downloadSale,
			downloadSaleTicket,
			downLoadUniqueTicket,
			filterBookings,
			filterProducts,
			filterSummary,
			generateSale,
			getExtraBed,
			getCrib,
			getSaleId,
			getServicesPrices,
			getTypeAndCodeRoom,
			getTypeDocumentName,
			goToCalendar,
			goToSummary,
			igvExonerated,
			loadBankAccounts,
			loadBillings,
			loadBillingDetail,
			loadBookingData,
			loadBookingHistory,
			loadCities,
			loadCurrencies,
			loadEmails,
			loadExchangeRate,
			loadNotes,
			loadResources,
			loadRooms,
			loadSaleResources,
			loadSummaryCategories,
			loadSummaryData,
			loadSummaryProducts,
			loadWarehouses,
			notesColumnSortableEvent,
			openBillingDetail,
			openBillingPay,
			openDeleteConfirm,
			openDeleteCustomer,
			openProductsModal,
			openSaleModal,
			payBilling,
			positiveValue,
			previewEmail,
			saveCustomer,
			saveData,
			saveNote,
			searchByColumn,
			searchCustomer,
			searchCustomerByMixin,
			searchCustomerNew,
			searchCustomerSale,
			searchProductsByColumn,
			selectBed,
			selectCrib,
			selectCategory,
			selectFilter,
			setPaymentMethod,
			setTypeDocument,
			setTypePayment,
			showChannelData,
			showCustomerData,
			showError,
			showGuestForm,
			showSummaryOption,
			toggleIconBirthDate,
			toggleIconEndDate,
			toggleIconProductDate,
			toggleIconStartDate,
			updateChannel,
			updateNote,
			updateProducts,
			validateExoneration,
			updateCheckOut,
			goToBill,
		},
		mixins: mixin,
		props: ['hotelId', 'roomTypeId'],
		validations,
		watch: {
			active,
		},
	};
</script>

<style lang="scss" scoped>
	.btn-blue {
		background-color: #29abe2 !important;
		color: white;
	}

	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 55px;
		width: 100%;

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}

		.border-select {
			border-right: 2px solid rgba($color: map-get($colors, border-radio), $alpha: .3);
			padding-right: 10px !important;

			&:first-of-type {
				border-left: 2px solid rgba($color: map-get($colors, border-radio), $alpha: .3);
			}
		}

		.booking-number {
			color: map-get($map: $colors, $key: realtime-label);
			font-family: map-get($map: $fonts, $key: regular);
			font-size: map-get($map: $sizes, $key: sixteen);

			span {
				color: map-get($map: $colors, $key: blue-title);
				font-family: map-get($map: $fonts, $key: medium);
			}
		}
	}

	.label-title {
		color: map-get($colors, dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, fourteen);
	}

	.bar-data {
		align-items: center;
		background-color: white;
		box-shadow: 0 2px 5px 0 rgba($color: #000000, $alpha: .1);
		display: flex;
		height: 48px;
		justify-content: space-around;

		&-item {
			border-right: 1px solid map-get($colors, year-select);
			flex: 1 auto;

			&:last-of-type {
				border-right: 0px;
			}

			&.no-border {
				border-right: 0px;
			}

			p {
				color: map-get($colors, bg-chart);
				font-family: map-get($fonts, medium);
				font-size: map-get($sizes, fourteen);
				margin-bottom: 0px;

				span {
					color: map-get($colors, realtime-label);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
				}
			}
		}

		.bar-icon {
			font-size: map-get($map: $sizes, $key: twenty);
			justify-content: flex-start;
			width: 20px;
		}
	}

	.summary-footer-bar {
		background-color: map-get($colors, color-selected-item);
		color: white;

		p {
			font-family: map-get($fonts, bold);
			font-size: 18px;
			margin: 0px;
		}
	}

	.btn-action.filter {
		background-color: map-get($colors, default-skyblue) !important;
		color: white;
	}

	.filter-list {
		color: map-get($colors, default-button-color);
		display: flex;

		button.btn {
			background-color: white !important;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
			color: map-get($colors, default-button-color);
			height: 40px;
			margin-right: 14px;

			&.active {
				background-color: map-get($colors, default-skyblue) !important;
				color: white;
			}
		}
	}

	.btn-cancel {
		background-color: map-get($colors, calendary-red) !important;

		&.grey {
			background-color: map-get($colors, tag-menu-span) !important;
		}
	}

	.total-amount {
		color: map-get($colors, bg-chart);
		font-family: map-get($fonts, bold);
		font-size: 24px;
		text-transform: uppercase;
	}

	.col-without-label {
		margin-top: 17.5px !important;
	}

	.container-flex {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// NewForm.vue?3d0d39c0